// If any video is being removed.
// 1. Remove from below and add in deltedVideos.
// 2. Remove from allVideos.json
// 3. Remove from video table and submit table if exists.
// 4. add a video here to make the count always 250.
// 5. update the video table of the newly added video. so that it will have live sequenceid and videoType as Live.
// 6. The sequence should be the same for new video and deleted video
const videos = [
 {
  "url1": "1207520015",
  "url2": "fadf5b4e80",
  "author": "Juno",
  "cityLocation": "Braunschweig - Germany",
  "Latitude": "52.2646577",
  "Longitude": "10.5236066",
  "Interiors": false,
  "Water": false,
  "Snow": false,
  "Animals": true,
  "DayVideo": false,
  "City": false,
  "Rain": false,
  "Nature": true,
  "Night": false,
  "dateRecording": 1783296000,
  "timeRecording": "22:00",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 1
 },
 {
  "url1": "1207763309",
  "url2": "dbfd7cf55d",
  "author": "DG",
  "cityLocation": "Pashan, Pune - India",
  "Latitude": "18.5386704",
  "Longitude": "73.7952542",
  "Interiors": false,
  "Water": false,
  "Snow": false,
  "Animals": false,
  "DayVideo": true,
  "City": true,
  "Rain": false,
  "Nature": true,
  "Night": false,
  "dateRecording": 1783382400,
  "timeRecording": "16:00",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 2
 },
 {
  "url1": "1207810565",
  "url2": "dd1212a708",
  "author": "DG",
  "cityLocation": "Pune - India",
  "Latitude": "18.5213738",
  "Longitude": "73.8545071",
  "Interiors": false,
  "Water": true,
  "Snow": false,
  "Animals": false,
  "DayVideo": false,
  "City": false,
  "Rain": true,
  "Nature": false,
  "Night": false,
  "dateRecording": 1783382400,
  "timeRecording": "18:00",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 3
 },
 {
  "url1": "1207852136",
  "url2": "c93a0f2000",
  "author": "MAIIII",
  "cityLocation": "GA,USA - USA",
  "Latitude": "34.3679819",
  "Longitude": "-84.3728716",
  "Interiors": false,
  "Water": false,
  "Snow": false,
  "Animals": true,
  "DayVideo": false,
  "City": false,
  "Rain": false,
  "Nature": false,
  "Night": false,
  "dateRecording": 1783382400,
  "timeRecording": "13:40",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 4
 },
 {
  "url1": "1208535426",
  "url2": "915e1047d0",
  "author": "Jeremy",
  "cityLocation": "Westland, MI - USA",
  "Latitude": "42.3238056",
  "Longitude": "-83.4005321",
  "Interiors": false,
  "Water": false,
  "Snow": false,
  "Animals": false,
  "DayVideo": false,
  "City": false,
  "Rain": true,
  "Nature": true,
  "Night": false,
  "dateRecording": 1783555200,
  "timeRecording": "14:30",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 5
 },
 {
  "url1": "1208109645",
  "url2": "299e19d53f",
  "author": "Penobscot Bay",
  "cityLocation": "Maine - USA",
  "Latitude": "45.7090970",
  "Longitude": "-68.8590201",
  "Interiors": false,
  "Water": true,
  "Snow": false,
  "Animals": false,
  "DayVideo": true,
  "City": false,
  "Rain": false,
  "Nature": false,
  "Night": false,
  "dateRecording": 1783468800,
  "timeRecording": "05:01",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 6
 },
 {
  "url1": "1207993011",
  "url2": "baba845380",
  "author": "Suvino",
  "cityLocation": "Palakkad , kerala - India",
  "Latitude": "10.7873692",
  "Longitude": "76.4742172",
  "Interiors": false,
  "Water": true,
  "Snow": false,
  "Animals": false,
  "DayVideo": true,
  "City": false,
  "Rain": false,
  "Nature": true,
  "Night": false,
  "dateRecording": 1783468800,
  "timeRecording": "11:37",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 7
 },
 {
  "url1": "1207992978",
  "url2": "020e915bdc",
  "author": "Aléa",
  "cityLocation": "Strasbourg - France",
  "Latitude": "48.5846140",
  "Longitude": "7.7507127",
  "Interiors": false,
  "Water": false,
  "Snow": false,
  "Animals": false,
  "DayVideo": true,
  "City": true,
  "Rain": false,
  "Nature": false,
  "Night": false,
  "dateRecording": 1783468800,
  "timeRecording": "04:00",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 8
 },
 {
  "url1": "1208971997",
  "url2": "78ee5876af",
  "author": "Stormy Evening",
  "cityLocation": "St. Louis, MO - USA",
  "Latitude": "38.6280278",
  "Longitude": "-90.1910154",
  "Interiors": false,
  "Water": false,
  "Snow": false,
  "Animals": false,
  "DayVideo": true,
  "City": false,
  "Rain": true,
  "Nature": true,
  "Night": false,
  "dateRecording": 1783641600,
  "timeRecording": "20:29",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 9
 },
 {
  "url1": "1208819769",
  "url2": "6b26f13c7d",
  "author": "Luchon France",
  "cityLocation": "Luchon - France",
  "Latitude": "42.7910617",
  "Longitude": "0.5912279",
  "Interiors": false,
  "Water": false,
  "Snow": false,
  "Animals": false,
  "DayVideo": true,
  "City": false,
  "Rain": false,
  "Nature": true,
  "Night": false,
  "dateRecording": 1783641600,
  "timeRecording": "15:15",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 10
 },
 {
  "url1": "1208677878",
  "url2": "738734b0f3",
  "author": "Raja Tun Uda Library",
  "cityLocation": "Shah Alam - Malaysia",
  "Latitude": "3.0739429",
  "Longitude": "101.5185278",
  "Interiors": false,
  "Water": true,
  "Snow": false,
  "Animals": false,
  "DayVideo": true,
  "City": true,
  "Rain": false,
  "Nature": true,
  "Night": false,
  "dateRecording": 1783641600,
  "timeRecording": "14:47",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 11
 },
 {
  "url1": "1208645435",
  "url2": "2749cd7e44",
  "author": "Pilot",
  "cityLocation": "NYC, New York - USA",
  "Latitude": "40.7127281",
  "Longitude": "-74.0060152",
  "Interiors": true,
  "Water": false,
  "Snow": false,
  "Animals": false,
  "DayVideo": true,
  "City": true,
  "Rain": false,
  "Nature": false,
  "Night": false,
  "dateRecording": 1783468800,
  "timeRecording": "10:35PM",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 12
 },
 {
  "url1": "1209326954",
  "url2": "a2d4262a7e",
  "author": "dc-rockx",
  "cityLocation": "Tennessee - USA",
  "Latitude": "35.7730076",
  "Longitude": "-86.2820081",
  "Interiors": false,
  "Water": false,
  "Snow": false,
  "Animals": false,
  "DayVideo": false,
  "City": false,
  "Rain": true,
  "Nature": false,
  "Night": false,
  "dateRecording": 1783814400,
  "timeRecording": "15:35",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 13
 },
 {
  "url1": "1209325144",
  "url2": "8d16b77db0",
  "author": "Jas",
  "cityLocation": "Guildford - UK",
  "Latitude": "51.2356068",
  "Longitude": "-0.5732063",
  "Interiors": false,
  "Water": false,
  "Snow": false,
  "Animals": false,
  "DayVideo": false,
  "City": false,
  "Rain": false,
  "Nature": false,
  "Night": true,
  "dateRecording": 1783814400,
  "timeRecording": "22:07",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 14
 },
 {
  "url1": "1209226184",
  "url2": "913abd0959",
  "author": "Sea View",
  "cityLocation": "Hurghada - Egypt",
  "Latitude": "27.2225560",
  "Longitude": "33.8307062",
  "Interiors": false,
  "Water": true,
  "Snow": false,
  "Animals": false,
  "DayVideo": true,
  "City": true,
  "Rain": false,
  "Nature": false,
  "Night": false,
  "dateRecording": 1783641600,
  "timeRecording": "14:18",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 15
 },
 {
  "url1": "1209117266",
  "url2": "f40ee97c05",
  "author": "Oksana",
  "cityLocation": "Saint Petersburg - Russia",
  "Latitude": "59.9606739",
  "Longitude": "30.1586551",
  "Interiors": false,
  "Water": false,
  "Snow": false,
  "Animals": false,
  "DayVideo": false,
  "City": false,
  "Rain": true,
  "Nature": false,
  "Night": true,
  "dateRecording": 1783728000,
  "timeRecording": "22:20",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 16
 },
 {
  "url1": "1209388114",
  "url2": "1a40cfa0a0",
  "author": "An usual street view",
  "cityLocation": "Singapore - Singapore",
  "Latitude": "1.3571070",
  "Longitude": "103.8194992",
  "Interiors": false,
  "Water": false,
  "Snow": false,
  "Animals": false,
  "DayVideo": true,
  "City": true,
  "Rain": false,
  "Nature": false,
  "Night": false,
  "dateRecording": 1783900800,
  "timeRecording": "11:30",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 17
 },
 {
  "url1": "1209477609",
  "url2": "ff625daa82",
  "author": "Mediterranean Sea",
  "cityLocation": "Mediterranean Sea - Spain",
  "Latitude": "",
  "Longitude": "",
  "Interiors": false,
  "Water": true,
  "Snow": false,
  "Animals": false,
  "DayVideo": true,
  "City": false,
  "Rain": false,
  "Nature": true,
  "Night": false,
  "dateRecording": 1758067200,
  "timeRecording": "11:28",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 18
 },
 {
  "url1": "1209502088",
  "url2": "64585f176c",
  "author": "Car Window",
  "cityLocation": "Punjab - India",
  "Latitude": "30.9293211",
  "Longitude": "75.5004841",
  "Interiors": false,
  "Water": false,
  "Snow": false,
  "Animals": false,
  "DayVideo": false,
  "City": true,
  "Rain": true,
  "Nature": true,
  "Night": false,
  "dateRecording": 1796601600,
  "timeRecording": "10:35PM",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 19
 },
 {
  "url1": "1209586017",
  "url2": "27f33d7185",
  "author": "Juan",
  "cityLocation": "Buenos Aires (CABA) - Argentina",
  "Latitude": "-34.6048076",
  "Longitude": "-58.3727355",
  "Interiors": false,
  "Water": false,
  "Snow": false,
  "Animals": false,
  "DayVideo": true,
  "City": true,
  "Rain": false,
  "Nature": false,
  "Night": false,
  "dateRecording": 1783900800,
  "timeRecording": "13:16",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 20
 },
 {
  "url1": "1210435875",
  "url2": "e0cabedf35",
  "author": "jerusalem",
  "cityLocation": "jerusalem - Israel",
  "Latitude": "31.7788472",
  "Longitude": "35.2257856",
  "Interiors": false,
  "Water": false,
  "Snow": false,
  "Animals": false,
  "DayVideo": false,
  "City": false,
  "Rain": false,
  "Nature": false,
  "Night": false,
  "dateRecording": 1784160000,
  "timeRecording": "12:30",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 21
 },
 {
  "url1": "1210152502",
  "url2": "ecfbc1e082",
  "author": "Manhattan",
  "cityLocation": "New York - USA",
  "Latitude": "40.7127281",
  "Longitude": "-74.0060152",
  "Interiors": false,
  "Water": false,
  "Snow": false,
  "Animals": false,
  "DayVideo": false,
  "City": true,
  "Rain": false,
  "Nature": false,
  "Night": true,
  "dateRecording": 1796601600,
  "timeRecording": "10:35PM",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 22
 },
 {
  "url1": "1210062045",
  "url2": "7e3cb5cc9f",
  "author": "rise lamp",
  "cityLocation": "Kaliningrad - Russia",
  "Latitude": "54.7046485",
  "Longitude": "20.4565666",
  "Interiors": false,
  "Water": false,
  "Snow": false,
  "Animals": false,
  "DayVideo": false,
  "City": false,
  "Rain": false,
  "Nature": true,
  "Night": true,
  "dateRecording": 1784073600,
  "timeRecording": "04:41",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 23
 },
 {
  "url1": "1209975640",
  "url2": "e6d6a521a7",
  "author": "Jorge Chilerecuerdos",
  "cityLocation": "Iquique - Chile",
  "Latitude": "-20.2140657",
  "Longitude": "-70.1524646",
  "Interiors": false,
  "Water": true,
  "Snow": false,
  "Animals": false,
  "DayVideo": false,
  "City": true,
  "Rain": false,
  "Nature": true,
  "Night": false,
  "dateRecording": 1783987200,
  "timeRecording": "08:00",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 24
 },
 {
  "url1": "1210442488",
  "url2": "7658de5511",
  "author": "City, Wrocław",
  "cityLocation": "Wrocław - Poland",
  "Latitude": "51.1263106",
  "Longitude": "16.9781963",
  "Interiors": false,
  "Water": false,
  "Snow": false,
  "Animals": false,
  "DayVideo": true,
  "City": true,
  "Rain": false,
  "Nature": false,
  "Night": false,
  "dateRecording": 1783468800,
  "timeRecording": "08:12",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 25
 },
 {
  "url1": "1210447041",
  "url2": "d91b733842",
  "author": "I.I.Kuxnetcov",
  "cityLocation": "Russia, Novouralsk - Russia",
  "Latitude": "",
  "Longitude": "",
  "Interiors": false,
  "Water": false,
  "Snow": false,
  "Animals": false,
  "DayVideo": false,
  "City": false,
  "Rain": false,
  "Nature": true,
  "Night": false,
  "dateRecording": 1784073600,
  "timeRecording": "21:08",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 26
 },
 {
  "url1": "1210456569",
  "url2": "16c64ea17e",
  "author": "Sunrise on the deck",
  "cityLocation": "Raleigh, NC - USA",
  "Latitude": "35.7803977",
  "Longitude": "-78.6390989",
  "Interiors": false,
  "Water": false,
  "Snow": false,
  "Animals": false,
  "DayVideo": false,
  "City": true,
  "Rain": false,
  "Nature": true,
  "Night": false,
  "dateRecording": 1784160000,
  "timeRecording": "06:03",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 27
 },
 {
  "url1": "1210470604",
  "url2": "fca8235f7b",
  "author": "Nehal",
  "cityLocation": "County Cork - Ireland",
  "Latitude": "51.9175359",
  "Longitude": "-8.5859773",
  "Interiors": false,
  "Water": false,
  "Snow": false,
  "Animals": false,
  "DayVideo": true,
  "City": false,
  "Rain": false,
  "Nature": true,
  "Night": false,
  "dateRecording": 1784160000,
  "timeRecording": "12:20",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 28
 },
 {
  "url1": "1210918366",
  "url2": "acc7671e92",
  "author": "Soothing Rain",
  "cityLocation": "Smyrna, GA - USA",
  "Latitude": "33.8838870",
  "Longitude": "-84.5147454",
  "Interiors": false,
  "Water": false,
  "Snow": false,
  "Animals": false,
  "DayVideo": true,
  "City": false,
  "Rain": true,
  "Nature": false,
  "Night": false,
  "dateRecording": 1784246400,
  "timeRecording": "10:35PM",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 29
 },
 {
  "url1": "1210904166",
  "url2": "969b3d6c8f",
  "author": "Louver",
  "cityLocation": "Oahu, HI - USA",
  "Latitude": "21.4834365",
  "Longitude": "-158.0364837",
  "Interiors": false,
  "Water": false,
  "Snow": false,
  "Animals": false,
  "DayVideo": true,
  "City": false,
  "Rain": false,
  "Nature": true,
  "Night": false,
  "dateRecording": 1784246400,
  "timeRecording": "10:00",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 30
 },
 {
  "url1": "1210708441",
  "url2": "68c8e7050e",
  "author": "k",
  "cityLocation": "Seocho, Seoul - South Korea",
  "Latitude": "37.4835000",
  "Longitude": "127.0322000",
  "Interiors": false,
  "Water": false,
  "Snow": false,
  "Animals": false,
  "DayVideo": true,
  "City": true,
  "Rain": false,
  "Nature": false,
  "Night": false,
  "dateRecording": 1784246400,
  "timeRecording": "14:30",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 31
 },
 {
  "url1": "1210597204",
  "url2": "f0fb09899a",
  "author": "Emma",
  "cityLocation": "Bloomington, IN - USA",
  "Latitude": "39.1670396",
  "Longitude": "-86.5342881",
  "Interiors": false,
  "Water": false,
  "Snow": false,
  "Animals": false,
  "DayVideo": true,
  "City": true,
  "Rain": false,
  "Nature": false,
  "Night": false,
  "dateRecording": 1784073600,
  "timeRecording": "14:58",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 32
 },
 {
  "url1": "1211128901",
  "url2": "ba632134db",
  "author": "Blah K C",
  "cityLocation": "Chennai, Tamil Nadu - India",
  "Latitude": "13.0836939",
  "Longitude": "80.2701860",
  "Interiors": false,
  "Water": false,
  "Snow": false,
  "Animals": false,
  "DayVideo": false,
  "City": true,
  "Rain": false,
  "Nature": false,
  "Night": false,
  "dateRecording": 1784419200,
  "timeRecording": "12:00",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 33
 },
 {
  "url1": "1211143554",
  "url2": "d618903e0b",
  "author": "Massachusetts",
  "cityLocation": ",Massachusets - USA",
  "Latitude": "38.8897188",
  "Longitude": "-77.0408758",
  "Interiors": false,
  "Water": false,
  "Snow": false,
  "Animals": false,
  "DayVideo": false,
  "City": false,
  "Rain": false,
  "Nature": true,
  "Night": true,
  "dateRecording": 1784419200,
  "timeRecording": "05:23",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 34
 },
 {
  "url1": "1211152590",
  "url2": "1b9fa73b22",
  "author": "Sofia",
  "cityLocation": "Zagreb - Croatia",
  "Latitude": "45.8130967",
  "Longitude": "15.9772795",
  "Interiors": false,
  "Water": false,
  "Snow": false,
  "Animals": false,
  "DayVideo": true,
  "City": false,
  "Rain": false,
  "Nature": true,
  "Night": false,
  "dateRecording": 1784332800,
  "timeRecording": "16:30",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 35
 },
 {
  "url1": "1211171700",
  "url2": "9c5af3fbe9",
  "author": "Patio In Progress",
  "cityLocation": "Ukiah, California - USA",
  "Latitude": "39.1501662",
  "Longitude": "-123.2077861",
  "Interiors": false,
  "Water": false,
  "Snow": false,
  "Animals": true,
  "DayVideo": true,
  "City": false,
  "Rain": false,
  "Nature": true,
  "Night": false,
  "dateRecording": 1784419200,
  "timeRecording": "07:00",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 36
 },
 {
  "url1": "1211176422",
  "url2": "e6f895a63c",
  "author": "Wooncoöperatie De Warren",
  "cityLocation": "Amsterdam - Netherlands",
  "Latitude": "52.3730796",
  "Longitude": "4.8924534",
  "Interiors": true,
  "Water": false,
  "Snow": false,
  "Animals": false,
  "DayVideo": true,
  "City": false,
  "Rain": false,
  "Nature": false,
  "Night": false,
  "dateRecording": 1784419200,
  "timeRecording": "11:17",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 37
 },
 {
  "url1": "1211175746",
  "url2": "9f2cdc2691",
  "author": "Peyton",
  "cityLocation": "Columbus, New Jersey - USA",
  "Latitude": "40.0726112",
  "Longitude": "-74.7207156",
  "Interiors": false,
  "Water": false,
  "Snow": false,
  "Animals": true,
  "DayVideo": true,
  "City": false,
  "Rain": false,
  "Nature": false,
  "Night": false,
  "dateRecording": 1784419200,
  "timeRecording": "10:35",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 38
 },
 {
  "url1": "1211174753",
  "url2": "5dd4affedd",
  "author": "Wooncoöperatie De Warren",
  "cityLocation": "Amsterdam - Netherlands",
  "Latitude": "52.3730796",
  "Longitude": "4.8924534",
  "Interiors": false,
  "Water": false,
  "Snow": false,
  "Animals": false,
  "DayVideo": true,
  "City": true,
  "Rain": false,
  "Nature": false,
  "Night": false,
  "dateRecording": 1784419200,
  "timeRecording": "10:54",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 39
 },
 {
  "url1": "1211172494",
  "url2": "5770ae58c7",
  "author": "Wooncoöperatie De Warren",
  "cityLocation": "Amsterdam - Netherlands",
  "Latitude": "52.3730796",
  "Longitude": "4.8924534",
  "Interiors": true,
  "Water": false,
  "Snow": false,
  "Animals": false,
  "DayVideo": true,
  "City": false,
  "Rain": false,
  "Nature": true,
  "Night": false,
  "dateRecording": 1784419200,
  "timeRecording": "14:18",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 40
 },
 {
  "url1": "1211206770",
  "url2": "2f37daabfe",
  "author": "Nature",
  "cityLocation": "Lago Vista, Texas - USA",
  "Latitude": "30.4601975",
  "Longitude": "-97.9883477",
  "Interiors": false,
  "Water": false,
  "Snow": false,
  "Animals": true,
  "DayVideo": true,
  "City": false,
  "Rain": false,
  "Nature": true,
  "Night": false,
  "dateRecording": 1784419200,
  "timeRecording": "13:45",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 41
 },
 {
  "url1": "1211194061",
  "url2": "7d394220df",
  "author": "Mac",
  "cityLocation": "Columbus, Montana - USA",
  "Latitude": "45.6366114",
  "Longitude": "-109.2521540",
  "Interiors": false,
  "Water": false,
  "Snow": false,
  "Animals": false,
  "DayVideo": true,
  "City": false,
  "Rain": false,
  "Nature": true,
  "Night": false,
  "dateRecording": 1784419200,
  "timeRecording": "10:51",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 42
 },
 {
  "url1": "1211187831",
  "url2": "e915b648a8",
  "author": "Southern front yard",
  "cityLocation": "Arkansas - USA",
  "Latitude": "35.2048883",
  "Longitude": "-92.4479108",
  "Interiors": false,
  "Water": false,
  "Snow": false,
  "Animals": false,
  "DayVideo": true,
  "City": false,
  "Rain": false,
  "Nature": true,
  "Night": false,
  "dateRecording": 1784419200,
  "timeRecording": "11:18",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 43
 },
 {
  "url1": "1211177829",
  "url2": "451a0a6383",
  "author": "Wooncoöperatie De Warren",
  "cityLocation": "Amsterdam - Netherlands",
  "Latitude": "52.3730796",
  "Longitude": "4.8924534",
  "Interiors": true,
  "Water": false,
  "Snow": false,
  "Animals": false,
  "DayVideo": true,
  "City": true,
  "Rain": false,
  "Nature": false,
  "Night": false,
  "dateRecording": 1784419200,
  "timeRecording": "10:54",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 44
 },
 {
  "url1": "1211234949",
  "url2": "955f0b1113",
  "author": "Logan",
  "cityLocation": "Florida - USA",
  "Latitude": "27.7567667",
  "Longitude": "-81.4639835",
  "Interiors": false,
  "Water": false,
  "Snow": true,
  "Animals": true,
  "DayVideo": false,
  "City": true,
  "Rain": false,
  "Nature": false,
  "Night": true,
  "dateRecording": 1784419200,
  "timeRecording": "19:07",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 45
 },
 {
  "url1": "1211241916",
  "url2": "b2f0e7d26b",
  "author": "Ember",
  "cityLocation": "Nuh uh - USA",
  "Latitude": "",
  "Longitude": "",
  "Interiors": false,
  "Water": false,
  "Snow": false,
  "Animals": true,
  "DayVideo": true,
  "City": false,
  "Rain": false,
  "Nature": false,
  "Night": false,
  "dateRecording": 1784419200,
  "timeRecording": "15:00",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 46
 },
 {
  "url1": "1211244962",
  "url2": "364fdbd29e",
  "author": "Fatima",
  "cityLocation": "Buch Villas - Pakistan",
  "Latitude": "",
  "Longitude": "",
  "Interiors": false,
  "Water": false,
  "Snow": false,
  "Animals": false,
  "DayVideo": true,
  "City": false,
  "Rain": false,
  "Nature": true,
  "Night": false,
  "dateRecording": 1784505600,
  "timeRecording": "05:25",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 47
 },
 {
  "url1": "1211251100",
  "url2": "596d152fbb",
  "author": "Into the Woods",
  "cityLocation": "Cincinnati - USA",
  "Latitude": "39.1014537",
  "Longitude": "-84.5124602",
  "Interiors": true,
  "Water": true,
  "Snow": true,
  "Animals": false,
  "DayVideo": false,
  "City": true,
  "Rain": true,
  "Nature": false,
  "Night": true,
  "dateRecording": 1784419200,
  "timeRecording": "20:30",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 48
 },
 {
  "url1": "1211548106",
  "url2": "60106259b6",
  "author": "Axel",
  "cityLocation": "Nashville, Tennessee - USA",
  "Latitude": "36.1622767",
  "Longitude": "-86.7742984",
  "Interiors": false,
  "Water": false,
  "Snow": false,
  "Animals": false,
  "DayVideo": true,
  "City": false,
  "Rain": false,
  "Nature": true,
  "Night": false,
  "dateRecording": 1784505600,
  "timeRecording": "20:00",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 49
 },
 {
  "url1": "1211543072",
  "url2": "a2ad44c703",
  "author": "Road views",
  "cityLocation": "Adelaide - Australia",
  "Latitude": "-34.9281805",
  "Longitude": "138.5999312",
  "Interiors": false,
  "Water": false,
  "Snow": false,
  "Animals": false,
  "DayVideo": true,
  "City": true,
  "Rain": false,
  "Nature": true,
  "Night": false,
  "dateRecording": 1766448000,
  "timeRecording": "18:30",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 50
 },
 {
  "url1": "1211486770",
  "url2": "3e2a6ce9dd",
  "author": "Alex",
  "cityLocation": "NJ - USA",
  "Latitude": "40.0757384",
  "Longitude": "-74.4041622",
  "Interiors": false,
  "Water": false,
  "Snow": false,
  "Animals": false,
  "DayVideo": true,
  "City": false,
  "Rain": false,
  "Nature": true,
  "Night": false,
  "dateRecording": 1784419200,
  "timeRecording": "15:54",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 51
 },
 {
  "url1": "1211441846",
  "url2": "da3827daf0",
  "author": "Logan",
  "cityLocation": "Florida - USA",
  "Latitude": "27.7567667",
  "Longitude": "-81.4639835",
  "Interiors": false,
  "Water": true,
  "Snow": false,
  "Animals": false,
  "DayVideo": false,
  "City": false,
  "Rain": true,
  "Nature": true,
  "Night": false,
  "dateRecording": 1784505600,
  "timeRecording": "13:27",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 52
 },
 {
  "url1": "1211554196",
  "url2": "8e714a0c67",
  "author": "Garden",
  "cityLocation": "Para hills - Australia",
  "Latitude": "-34.8117394",
  "Longitude": "138.6556036",
  "Interiors": false,
  "Water": false,
  "Snow": false,
  "Animals": false,
  "DayVideo": true,
  "City": false,
  "Rain": false,
  "Nature": true,
  "Night": false,
  "dateRecording": 1766448000,
  "timeRecording": "11:20",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 53
 },
 {
  "url1": "1211808496",
  "url2": "743203c275",
  "author": "D and J",
  "cityLocation": "Cotswolds - UK",
  "Latitude": "51.7489426",
  "Longitude": "-0.2303335",
  "Interiors": false,
  "Water": false,
  "Snow": false,
  "Animals": false,
  "DayVideo": true,
  "City": false,
  "Rain": false,
  "Nature": true,
  "Night": false,
  "dateRecording": 1784592000,
  "timeRecording": "20:45",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 54
 },
 {
  "url1": "1211812221",
  "url2": "e8630fee86",
  "author": "Faith A",
  "cityLocation": "Buffalo Grove, IL - USA",
  "Latitude": "42.1544205",
  "Longitude": "-87.9589621",
  "Interiors": false,
  "Water": false,
  "Snow": false,
  "Animals": false,
  "DayVideo": true,
  "City": false,
  "Rain": false,
  "Nature": true,
  "Night": false,
  "dateRecording": 1784505600,
  "timeRecording": "15:26",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 55
 },
 {
  "url1": "1211950633",
  "url2": "a645f8e474",
  "author": "Horst",
  "cityLocation": "Saarbrücken - Germany",
  "Latitude": "49.2343620",
  "Longitude": "6.9963790",
  "Interiors": false,
  "Water": false,
  "Snow": false,
  "Animals": false,
  "DayVideo": true,
  "City": true,
  "Rain": false,
  "Nature": false,
  "Night": false,
  "dateRecording": 1784678400,
  "timeRecording": "10:45",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 56
 },
 {
  "url1": "1212308712",
  "url2": "6deef3f54d",
  "author": "Fra vai a toccare l'erba",
  "cityLocation": "San Gregorio - Italia",
  "Latitude": "45.1391347",
  "Longitude": "7.0236896",
  "Interiors": false,
  "Water": false,
  "Snow": false,
  "Animals": false,
  "DayVideo": true,
  "City": true,
  "Rain": false,
  "Nature": false,
  "Night": false,
  "dateRecording": 1784764800,
  "timeRecording": "13:55",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 57
 },
 {
  "url1": "1212212054",
  "url2": "fef129f41d",
  "author": "Our view",
  "cityLocation": "Sydney Harbour, Manly - Australia",
  "Latitude": "-33.8128845",
  "Longitude": "151.2905582",
  "Interiors": false,
  "Water": true,
  "Snow": false,
  "Animals": false,
  "DayVideo": true,
  "City": true,
  "Rain": false,
  "Nature": false,
  "Night": false,
  "dateRecording": 1784764800,
  "timeRecording": "12:20",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 58
 },
 {
  "url1": "1212158964",
  "url2": "b0c48d034e",
  "author": "Rhett",
  "cityLocation": "Cambridge, Massachusetts - USA",
  "Latitude": "42.3656347",
  "Longitude": "-71.1040018",
  "Interiors": false,
  "Water": false,
  "Snow": false,
  "Animals": false,
  "DayVideo": true,
  "City": true,
  "Rain": false,
  "Nature": false,
  "Night": false,
  "dateRecording": 1784592000,
  "timeRecording": "17:00",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 59
 },
 {
  "url1": "1212125917",
  "url2": "a3ba4e65ac",
  "author": "Andy",
  "cityLocation": "Loughborough - UK",
  "Latitude": "52.7723859",
  "Longitude": "-1.2077985",
  "Interiors": false,
  "Water": false,
  "Snow": false,
  "Animals": false,
  "DayVideo": true,
  "City": false,
  "Rain": false,
  "Nature": true,
  "Night": false,
  "dateRecording": 1784678400,
  "timeRecording": "20:37",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 60
 },
 {
  "url1": "1212315017",
  "url2": "d01d25548a",
  "author": "Trees from windowside",
  "cityLocation": "Pune, Maharashtra - India",
  "Latitude": "18.5213738",
  "Longitude": "73.8545071",
  "Interiors": false,
  "Water": true,
  "Snow": false,
  "Animals": false,
  "DayVideo": true,
  "City": false,
  "Rain": true,
  "Nature": true,
  "Night": false,
  "dateRecording": 1784764800,
  "timeRecording": "17:45",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 61
 },
 {
  "url1": "1212389665",
  "url2": "fecb245b1a",
  "author": "Eastbound to Salem",
  "cityLocation": "Northern NY - USA",
  "Latitude": "40.7614258",
  "Longitude": "-73.8448851",
  "Interiors": true,
  "Water": false,
  "Snow": true,
  "Animals": false,
  "DayVideo": false,
  "City": false,
  "Rain": true,
  "Nature": false,
  "Night": true,
  "dateRecording": 1784764800,
  "timeRecording": "11:30",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 62
 },
 {
  "url1": "1212406791",
  "url2": "a0646a0415",
  "author": "Nickiboy",
  "cityLocation": "Saxony - Deutschland",
  "Latitude": "50.9295798",
  "Longitude": "13.4585052",
  "Interiors": false,
  "Water": false,
  "Snow": false,
  "Animals": false,
  "DayVideo": true,
  "City": false,
  "Rain": false,
  "Nature": true,
  "Night": false,
  "dateRecording": 1784764800,
  "timeRecording": "18:48",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 63
 },
 {
  "url1": "1212559006",
  "url2": "95f665f17b",
  "author": "Sohee",
  "cityLocation": "Songtan - South Korea",
  "Latitude": "37.0753560",
  "Longitude": "127.0543657",
  "Interiors": false,
  "Water": false,
  "Snow": false,
  "Animals": false,
  "DayVideo": true,
  "City": false,
  "Rain": false,
  "Nature": false,
  "Night": false,
  "dateRecording": 1784851200,
  "timeRecording": "15:07",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 64
 },
 {
  "url1": "1212686462",
  "url2": "65f9033e7e",
  "author": "Neila",
  "cityLocation": "Cuba, New Mexico - USA",
  "Latitude": "36.0219333",
  "Longitude": "-106.9584280",
  "Interiors": false,
  "Water": false,
  "Snow": false,
  "Animals": true,
  "DayVideo": true,
  "City": false,
  "Rain": false,
  "Nature": true,
  "Night": false,
  "dateRecording": 1784851200,
  "timeRecording": "08:45",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 65
 },
 {
  "url1": "1212645404",
  "url2": "9c5dcf8805",
  "author": "Samantha",
  "cityLocation": "Delhi - India",
  "Latitude": "28.6138954",
  "Longitude": "77.2090057",
  "Interiors": false,
  "Water": false,
  "Snow": false,
  "Animals": false,
  "DayVideo": false,
  "City": false,
  "Rain": false,
  "Nature": false,
  "Night": true,
  "dateRecording": 1784678400,
  "timeRecording": "01:00",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 66
 },
 {
  "url1": "1212636848",
  "url2": "c3d161c2b3",
  "author": "W",
  "cityLocation": "Han River in Seoul - South Korea",
  "Latitude": "",
  "Longitude": "",
  "Interiors": false,
  "Water": true,
  "Snow": false,
  "Animals": false,
  "DayVideo": true,
  "City": true,
  "Rain": false,
  "Nature": true,
  "Night": false,
  "dateRecording": 1783728000,
  "timeRecording": "14:56",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 67
 },
 {
  "url1": "1212630363",
  "url2": "e6d5d0557c",
  "author": "Pacaembu",
  "cityLocation": "São Paulo - Brazil",
  "Latitude": "-23.5506507",
  "Longitude": "-46.6333824",
  "Interiors": true,
  "Water": false,
  "Snow": false,
  "Animals": false,
  "DayVideo": true,
  "City": true,
  "Rain": false,
  "Nature": false,
  "Night": false,
  "dateRecording": 1784851200,
  "timeRecording": "08:45",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 68
 },
 {
  "url1": "1212690826",
  "url2": "61f3edd80a",
  "author": "Airport Ops",
  "cityLocation": "Orlando Florida - USA",
  "Latitude": "28.5421109",
  "Longitude": "-81.3790304",
  "Interiors": false,
  "Water": false,
  "Snow": false,
  "Animals": false,
  "DayVideo": true,
  "City": true,
  "Rain": false,
  "Nature": false,
  "Night": false,
  "dateRecording": 1767744000,
  "timeRecording": "13:16",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 69
 },
 {
  "url1": "1212731054",
  "url2": "a5c793e2b2",
  "author": "Sidinei",
  "cityLocation": "Santa Catarina - Brazil",
  "Latitude": "-27.0628367",
  "Longitude": "-51.1149650",
  "Interiors": true,
  "Water": false,
  "Snow": false,
  "Animals": false,
  "DayVideo": false,
  "City": false,
  "Rain": false,
  "Nature": false,
  "Night": false,
  "dateRecording": 1784851200,
  "timeRecording": "14:45",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 70
 },
 {
  "url1": "1212760058",
  "url2": "58f1c71621",
  "author": "Pouso no Santos Dumont",
  "cityLocation": "Rio de Janeiro - Brazil",
  "Latitude": "-22.9110137",
  "Longitude": "-43.2093727",
  "Interiors": false,
  "Water": false,
  "Snow": false,
  "Animals": false,
  "DayVideo": true,
  "City": true,
  "Rain": false,
  "Nature": false,
  "Night": false,
  "dateRecording": 1768780800,
  "timeRecording": "16:00",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 71
 },
 {
  "url1": "1212816122",
  "url2": "9f4dca7ceb",
  "author": "Leighton",
  "cityLocation": "Cau Giay, Hanoi - Việt Nam",
  "Latitude": "21.0292159",
  "Longitude": "105.8033629",
  "Interiors": false,
  "Water": true,
  "Snow": false,
  "Animals": false,
  "DayVideo": false,
  "City": true,
  "Rain": true,
  "Nature": false,
  "Night": true,
  "dateRecording": 1784937600,
  "timeRecording": "04:40",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 72
 },
 {
  "url1": "1212904324",
  "url2": "349fdfac68",
  "author": "Angela",
  "cityLocation": "Rio Grande do Sul - Brazil",
  "Latitude": "-29.8425284",
  "Longitude": "-53.7680577",
  "Interiors": false,
  "Water": false,
  "Snow": false,
  "Animals": false,
  "DayVideo": true,
  "City": false,
  "Rain": false,
  "Nature": true,
  "Night": false,
  "dateRecording": 1784937600,
  "timeRecording": "11:30",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 73
 },
 {
  "url1": "1212834387",
  "url2": "63baf97a46",
  "author": "SG",
  "cityLocation": "Mangalore, Karnataka - India",
  "Latitude": "12.8698101",
  "Longitude": "74.8430082",
  "Interiors": false,
  "Water": false,
  "Snow": false,
  "Animals": false,
  "DayVideo": true,
  "City": false,
  "Rain": false,
  "Nature": true,
  "Night": false,
  "dateRecording": 1784851200,
  "timeRecording": "09:00",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 74
 },
 {
  "url1": "1212826487",
  "url2": "44e3e88280",
  "author": "Former Farmboy",
  "cityLocation": "Tehaleh, WA - USA",
  "Latitude": "47.1224094",
  "Longitude": "-122.1710904",
  "Interiors": false,
  "Water": false,
  "Snow": false,
  "Animals": false,
  "DayVideo": true,
  "City": false,
  "Rain": true,
  "Nature": true,
  "Night": false,
  "dateRecording": 1782259200,
  "timeRecording": "09:41",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 75
 },
 {
  "url1": "1212816689",
  "url2": "d4b3e73137",
  "author": "Leighton",
  "cityLocation": "Cau Giay, Hanoi - Vietnam",
  "Latitude": "21.0292159",
  "Longitude": "105.8033629",
  "Interiors": false,
  "Water": true,
  "Snow": false,
  "Animals": false,
  "DayVideo": true,
  "City": false,
  "Rain": true,
  "Nature": false,
  "Night": true,
  "dateRecording": -61329312000,
  "timeRecording": "10:07",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 76
 },
 {
  "url1": "1212920941",
  "url2": "e04968dcfb",
  "author": "Lewis",
  "cityLocation": "Bethlehem, PA - USA",
  "Latitude": "40.6178915",
  "Longitude": "-75.3786521",
  "Interiors": false,
  "Water": true,
  "Snow": false,
  "Animals": false,
  "DayVideo": true,
  "City": false,
  "Rain": false,
  "Nature": true,
  "Night": false,
  "dateRecording": 1601942400,
  "timeRecording": "14:22",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 77
 },
 {
  "url1": "1212944821",
  "url2": "a96c48c27f",
  "author": "Pilot",
  "cityLocation": "Hoboken, New Jersey - USA",
  "Latitude": "40.7433066",
  "Longitude": "-74.0323752",
  "Interiors": true,
  "Water": false,
  "Snow": false,
  "Animals": false,
  "DayVideo": true,
  "City": true,
  "Rain": false,
  "Nature": false,
  "Night": false,
  "dateRecording": 1784073600,
  "timeRecording": "10:35PM",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 78
 },
 {
  "url1": "1212972409",
  "url2": "c2f7b7c46f",
  "author": "Janela do quarto do gato",
  "cityLocation": "Nagano - Japão",
  "Latitude": "36.1143945",
  "Longitude": "138.0319015",
  "Interiors": false,
  "Water": false,
  "Snow": false,
  "Animals": false,
  "DayVideo": false,
  "City": false,
  "Rain": false,
  "Nature": true,
  "Night": false,
  "dateRecording": 1785024000,
  "timeRecording": "10:13",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 79
 },
 {
  "url1": "1212976940",
  "url2": "277a0af84b",
  "author": "Pilot",
  "cityLocation": "Hoboken to NYC - USA",
  "Latitude": "",
  "Longitude": "",
  "Interiors": true,
  "Water": false,
  "Snow": false,
  "Animals": false,
  "DayVideo": true,
  "City": true,
  "Rain": false,
  "Nature": false,
  "Night": false,
  "dateRecording": 1783987200,
  "timeRecording": "10:35PM",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 80
 },
 {
  "url1": "1213071816",
  "url2": "5d191ac964",
  "author": "Santiago",
  "cityLocation": "Córdoba - Argentina",
  "Latitude": "-31.4166867",
  "Longitude": "-64.1834193",
  "Interiors": false,
  "Water": false,
  "Snow": false,
  "Animals": false,
  "DayVideo": true,
  "City": false,
  "Rain": false,
  "Nature": false,
  "Night": false,
  "dateRecording": 1785024000,
  "timeRecording": "11:40",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 81
 },
 {
  "url1": "1213057228",
  "url2": "51d36694c7",
  "author": "Paulo - MAM",
  "cityLocation": "Rio de Janeiro - Brazil",
  "Latitude": "-22.9110137",
  "Longitude": "-43.2093727",
  "Interiors": false,
  "Water": false,
  "Snow": false,
  "Animals": false,
  "DayVideo": true,
  "City": false,
  "Rain": false,
  "Nature": true,
  "Night": false,
  "dateRecording": 1785024000,
  "timeRecording": "12:53",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 82
 },
 {
  "url1": "1213045296",
  "url2": "d3f5687966",
  "author": "Vero",
  "cityLocation": "HoChiMinh - Vietnam",
  "Latitude": "10.7238881",
  "Longitude": "106.7313051",
  "Interiors": false,
  "Water": false,
  "Snow": false,
  "Animals": false,
  "DayVideo": false,
  "City": false,
  "Rain": false,
  "Nature": false,
  "Night": true,
  "dateRecording": 1785024000,
  "timeRecording": "20:15",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 83
 },
 {
  "url1": "1212994213",
  "url2": "0c83430265",
  "author": "Vitaliy",
  "cityLocation": "Koltsovo, Novosibirsk - Russia",
  "Latitude": "54.9367736",
  "Longitude": "83.1871390",
  "Interiors": false,
  "Water": true,
  "Snow": false,
  "Animals": false,
  "DayVideo": false,
  "City": false,
  "Rain": true,
  "Nature": true,
  "Night": false,
  "dateRecording": 1785024000,
  "timeRecording": "09:35",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 84
 },
 {
  "url1": "1213080394",
  "url2": "9641b4f71f",
  "author": "Bird Friends",
  "cityLocation": "Hillsboro, Virginia - USA",
  "Latitude": "39.1986540",
  "Longitude": "-77.7244269",
  "Interiors": false,
  "Water": false,
  "Snow": false,
  "Animals": true,
  "DayVideo": true,
  "City": false,
  "Rain": false,
  "Nature": false,
  "Night": false,
  "dateRecording": 1783468800,
  "timeRecording": "08:06",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 85
 },
 {
  "url1": "1213087771",
  "url2": "ceaa41fc9c",
  "author": "Abingdon",
  "cityLocation": "Virginia - North Macedonia",
  "Latitude": "36.7301196",
  "Longitude": "-76.5648784",
  "Interiors": false,
  "Water": false,
  "Snow": false,
  "Animals": false,
  "DayVideo": true,
  "City": false,
  "Rain": false,
  "Nature": false,
  "Night": false,
  "dateRecording": 1785024000,
  "timeRecording": "15:48",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 86
 },
 {
  "url1": "1213094744",
  "url2": "10f3497e50",
  "author": "Janela Paraíso das Águas",
  "cityLocation": "Maceió - Brasil",
  "Latitude": "-9.6476843",
  "Longitude": "-35.7339264",
  "Interiors": false,
  "Water": true,
  "Snow": false,
  "Animals": false,
  "DayVideo": true,
  "City": false,
  "Rain": false,
  "Nature": true,
  "Night": false,
  "dateRecording": 1785024000,
  "timeRecording": "12:07",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 87
 },
 {
  "url1": "1213094790",
  "url2": "321695683d",
  "author": "Janela Paraíso das Águas",
  "cityLocation": "Maceió AL - Brasil",
  "Latitude": "-9.6175896",
  "Longitude": "-35.7467755",
  "Interiors": false,
  "Water": true,
  "Snow": false,
  "Animals": false,
  "DayVideo": true,
  "City": false,
  "Rain": false,
  "Nature": true,
  "Night": false,
  "dateRecording": 1784937600,
  "timeRecording": "12:29",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 88
 },
 {
  "url1": "1213555052",
  "url2": "f20d72c560",
  "author": "Grey",
  "cityLocation": "Cantabria - Spain",
  "Latitude": "43.1595664",
  "Longitude": "-4.0878382",
  "Interiors": false,
  "Water": false,
  "Snow": false,
  "Animals": true,
  "DayVideo": true,
  "City": false,
  "Rain": false,
  "Nature": true,
  "Night": false,
  "dateRecording": 1785196800,
  "timeRecording": "13:20",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 89
 },
 {
  "url1": "1213235973",
  "url2": "421490f800",
  "author": "Sunrise at the Park",
  "cityLocation": "Brasilia - Brazil",
  "Latitude": "-10.3333333",
  "Longitude": "-53.2000000",
  "Interiors": true,
  "Water": false,
  "Snow": false,
  "Animals": false,
  "DayVideo": true,
  "City": false,
  "Rain": false,
  "Nature": true,
  "Night": true,
  "dateRecording": 1785110400,
  "timeRecording": "06:32",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 90
 },
 {
  "url1": "1213114214",
  "url2": "1d47d5e159",
  "author": "Over Growth",
  "cityLocation": "Tennessee - USA",
  "Latitude": "35.7730076",
  "Longitude": "-86.2820081",
  "Interiors": false,
  "Water": false,
  "Snow": false,
  "Animals": false,
  "DayVideo": true,
  "City": false,
  "Rain": false,
  "Nature": true,
  "Night": false,
  "dateRecording": 1785024000,
  "timeRecording": "18:13",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 91
 },
 {
  "url1": "1213097868",
  "url2": "8835c49be6",
  "author": "Angela",
  "cityLocation": "Estância Velha-RS - Brasil",
  "Latitude": "-29.6583069",
  "Longitude": "-51.1492678",
  "Interiors": false,
  "Water": false,
  "Snow": false,
  "Animals": false,
  "DayVideo": true,
  "City": false,
  "Rain": false,
  "Nature": true,
  "Night": false,
  "dateRecording": 1785024000,
  "timeRecording": "16:44",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 92
 },
 {
  "url1": "1213590326",
  "url2": "aeb00f6eab",
  "author": "AlbertoChesini",
  "cityLocation": "São José dos Campos - Brazil",
  "Latitude": "-23.1867782",
  "Longitude": "-45.8854538",
  "Interiors": false,
  "Water": false,
  "Snow": false,
  "Animals": false,
  "DayVideo": true,
  "City": true,
  "Rain": false,
  "Nature": true,
  "Night": false,
  "dateRecording": 1785110400,
  "timeRecording": "17:32",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 93
 },
 {
  "url1": "1213598198",
  "url2": "66c9e5ea3e",
  "author": "Pergi",
  "cityLocation": "Hamburg - Germany",
  "Latitude": "53.5503410",
  "Longitude": "10.0006540",
  "Interiors": false,
  "Water": false,
  "Snow": false,
  "Animals": false,
  "DayVideo": true,
  "City": false,
  "Rain": false,
  "Nature": false,
  "Night": false,
  "dateRecording": 1785196800,
  "timeRecording": "16:01",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 94
 },
 {
  "url1": "1213607895",
  "url2": "f24e9c697f",
  "author": "Ohio Sunset",
  "cityLocation": "Columbus, Ohio - USA",
  "Latitude": "39.9622601",
  "Longitude": "-83.0007065",
  "Interiors": true,
  "Water": true,
  "Snow": true,
  "Animals": true,
  "DayVideo": false,
  "City": true,
  "Rain": false,
  "Nature": false,
  "Night": false,
  "dateRecording": 1785110400,
  "timeRecording": "20:30",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 95
 },
 {
  "url1": "1213618306",
  "url2": "439cf264d5",
  "author": "Sunset in Siberia",
  "cityLocation": "Kemerovo - Russia",
  "Latitude": "55.3550907",
  "Longitude": "86.0871213",
  "Interiors": false,
  "Water": false,
  "Snow": false,
  "Animals": false,
  "DayVideo": false,
  "City": true,
  "Rain": false,
  "Nature": false,
  "Night": false,
  "dateRecording": 1780185600,
  "timeRecording": "21:20",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 96
 },
 {
  "url1": "1213751910",
  "url2": "e6f41c211e",
  "author": "Christy",
  "cityLocation": "Panama City Beach, Fl - USA",
  "Latitude": "30.1765914",
  "Longitude": "-85.8053860",
  "Interiors": false,
  "Water": true,
  "Snow": false,
  "Animals": false,
  "DayVideo": true,
  "City": false,
  "Rain": false,
  "Nature": true,
  "Night": false,
  "dateRecording": 1784937600,
  "timeRecording": "08:30",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 97
 },
 {
  "url1": "1213695663",
  "url2": "9ddd571433",
  "author": "Casa",
  "cityLocation": "Rio de Janeiro - Brasil",
  "Latitude": "-22.9110137",
  "Longitude": "-43.2093727",
  "Interiors": false,
  "Water": false,
  "Snow": false,
  "Animals": false,
  "DayVideo": true,
  "City": true,
  "Rain": false,
  "Nature": true,
  "Night": false,
  "dateRecording": 1785196800,
  "timeRecording": "16:00",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 98
 },
 {
  "url1": "1213682770",
  "url2": "b82e4b86b9",
  "author": "Norway summer",
  "cityLocation": "Hovden - Norway",
  "Latitude": "60.8246206",
  "Longitude": "4.6638524",
  "Interiors": false,
  "Water": true,
  "Snow": false,
  "Animals": false,
  "DayVideo": true,
  "City": false,
  "Rain": false,
  "Nature": true,
  "Night": false,
  "dateRecording": 1785110400,
  "timeRecording": "18:50",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 99
 },
 {
  "url1": "1213628725",
  "url2": "cdd869ff16",
  "author": "Thunderstorm & lightning",
  "cityLocation": "Kemerovo - Russia",
  "Latitude": "55.3550907",
  "Longitude": "86.0871213",
  "Interiors": false,
  "Water": false,
  "Snow": false,
  "Animals": false,
  "DayVideo": false,
  "City": false,
  "Rain": true,
  "Nature": false,
  "Night": false,
  "dateRecording": 1780876800,
  "timeRecording": "22:00",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 100
 },
 {
  "url1": "1213846444",
  "url2": "8db90fc7bd",
  "author": "Vaidehi",
  "cityLocation": "Ahmedabad - India",
  "Latitude": "23.0215374",
  "Longitude": "72.5800568",
  "Interiors": false,
  "Water": false,
  "Snow": false,
  "Animals": false,
  "DayVideo": true,
  "City": false,
  "Rain": false,
  "Nature": true,
  "Night": false,
  "dateRecording": 1785283200,
  "timeRecording": "14:08",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 101
 },
 {
  "url1": "1213881094",
  "url2": "c5be72ddb0",
  "author": "Carmen Clemente",
  "cityLocation": "Murcia - Spain",
  "Latitude": "37.9923795",
  "Longitude": "-1.1305431",
  "Interiors": false,
  "Water": false,
  "Snow": false,
  "Animals": false,
  "DayVideo": true,
  "City": true,
  "Rain": false,
  "Nature": false,
  "Night": false,
  "dateRecording": 1785283200,
  "timeRecording": "13:16",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 102
 },
 {
  "url1": "1213888857",
  "url2": "495f1c3420",
  "author": "Meg",
  "cityLocation": "Logan, UT - USA",
  "Latitude": "41.7313063",
  "Longitude": "-111.8349140",
  "Interiors": false,
  "Water": true,
  "Snow": false,
  "Animals": false,
  "DayVideo": false,
  "City": true,
  "Rain": false,
  "Nature": true,
  "Night": true,
  "dateRecording": 1785196800,
  "timeRecording": "05:22",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 103
 },
 {
  "url1": "1213911012",
  "url2": "f849db9836",
  "author": "Jorge Villarreal",
  "cityLocation": "Medellín - Colombia",
  "Latitude": "6.2443382",
  "Longitude": "-75.5735530",
  "Interiors": false,
  "Water": false,
  "Snow": false,
  "Animals": false,
  "DayVideo": true,
  "City": true,
  "Rain": false,
  "Nature": false,
  "Night": false,
  "dateRecording": 1785283200,
  "timeRecording": "07:30",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 104
 },
 {
  "url1": "1214045169",
  "url2": "c7c3be0d0b",
  "author": "Christy",
  "cityLocation": "Panama City Beach, Fl - USA",
  "Latitude": "30.1765914",
  "Longitude": "-85.8053860",
  "Interiors": false,
  "Water": true,
  "Snow": false,
  "Animals": false,
  "DayVideo": false,
  "City": false,
  "Rain": false,
  "Nature": false,
  "Night": false,
  "dateRecording": 1784851200,
  "timeRecording": "09:30",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 105
 },
 {
  "url1": "1214041348",
  "url2": "f235e13ec3",
  "author": "Christy",
  "cityLocation": "Panama City Beach, Fl - USA",
  "Latitude": "30.1765914",
  "Longitude": "-85.8053860",
  "Interiors": false,
  "Water": true,
  "Snow": false,
  "Animals": false,
  "DayVideo": true,
  "City": false,
  "Rain": false,
  "Nature": false,
  "Night": false,
  "dateRecording": 1784937600,
  "timeRecording": "14:30",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 106
 },
 {
  "url1": "1214006905",
  "url2": "d15d2d1c61",
  "author": "Los chicos de mayorista",
  "cityLocation": "Mar del Plata - Argentina",
  "Latitude": "-37.9976168",
  "Longitude": "-57.5482079",
  "Interiors": false,
  "Water": false,
  "Snow": false,
  "Animals": false,
  "DayVideo": true,
  "City": true,
  "Rain": false,
  "Nature": false,
  "Night": false,
  "dateRecording": 1785283200,
  "timeRecording": "14:00",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 107
 },
 {
  "url1": "1213981285",
  "url2": "3d2edb1d81",
  "author": "Ahmad",
  "cityLocation": "Amman - Jordan",
  "Latitude": "31.9515694",
  "Longitude": "35.9239625",
  "Interiors": false,
  "Water": false,
  "Snow": false,
  "Animals": false,
  "DayVideo": true,
  "City": false,
  "Rain": false,
  "Nature": true,
  "Night": false,
  "dateRecording": 1785283200,
  "timeRecording": "19:40",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 108
 },
 {
  "url1": "1214070871",
  "url2": "2d14e81901",
  "author": "Jessi",
  "cityLocation": "Western Slope, Colorado - USA",
  "Latitude": "39.0670552",
  "Longitude": "-108.5572929",
  "Interiors": false,
  "Water": false,
  "Snow": false,
  "Animals": false,
  "DayVideo": true,
  "City": false,
  "Rain": false,
  "Nature": false,
  "Night": false,
  "dateRecording": 1785283200,
  "timeRecording": "14:45",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 109
 },
 {
  "url1": "1214083969",
  "url2": "a32aee6750",
  "author": "Christy",
  "cityLocation": "Moody , Alabama - USA",
  "Latitude": "33.5909365",
  "Longitude": "-86.4908168",
  "Interiors": false,
  "Water": false,
  "Snow": false,
  "Animals": false,
  "DayVideo": false,
  "City": false,
  "Rain": false,
  "Nature": true,
  "Night": false,
  "dateRecording": 1785283200,
  "timeRecording": "16:30",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 110
 },
 {
  "url1": "1214102094",
  "url2": "1a0e288541",
  "author": "Annastrasse",
  "cityLocation": "Darmstadt - Germany",
  "Latitude": "49.8727750",
  "Longitude": "8.6511770",
  "Interiors": false,
  "Water": false,
  "Snow": false,
  "Animals": false,
  "DayVideo": false,
  "City": true,
  "Rain": false,
  "Nature": false,
  "Night": true,
  "dateRecording": 1785283200,
  "timeRecording": "00:26",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 111
 },
 {
  "url1": "1214105698",
  "url2": "9020cab249",
  "author": "Carlos F. Figueiras",
  "cityLocation": "Tijuca, Rio de Janeiro - Brazil",
  "Latitude": "-22.9247351",
  "Longitude": "-43.2327165",
  "Interiors": false,
  "Water": false,
  "Snow": false,
  "Animals": false,
  "DayVideo": false,
  "City": true,
  "Rain": false,
  "Nature": true,
  "Night": false,
  "dateRecording": 1785110400,
  "timeRecording": "11:00",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 112
 },
 {
  "url1": "1214266271",
  "url2": "4fe8c89325",
  "author": "Misty Magic",
  "cityLocation": "Mussoorie - India",
  "Latitude": "30.4569012",
  "Longitude": "78.0782906",
  "Interiors": false,
  "Water": false,
  "Snow": false,
  "Animals": false,
  "DayVideo": true,
  "City": false,
  "Rain": false,
  "Nature": true,
  "Night": false,
  "dateRecording": 1785369600,
  "timeRecording": "15:30",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 113
 },
 {
  "url1": "1214231247",
  "url2": "047df10f13",
  "author": "Ahmad",
  "cityLocation": "Amman - Jordan",
  "Latitude": "31.9515694",
  "Longitude": "35.9239625",
  "Interiors": false,
  "Water": false,
  "Snow": false,
  "Animals": false,
  "DayVideo": false,
  "City": true,
  "Rain": false,
  "Nature": false,
  "Night": false,
  "dateRecording": 1785369600,
  "timeRecording": "13:00",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 114
 },
 {
  "url1": "1214217417",
  "url2": "6cea7cb795",
  "author": "Ahmad",
  "cityLocation": "Amman - Jordan",
  "Latitude": "31.9515694",
  "Longitude": "35.9239625",
  "Interiors": false,
  "Water": false,
  "Snow": false,
  "Animals": false,
  "DayVideo": false,
  "City": true,
  "Rain": false,
  "Nature": true,
  "Night": false,
  "dateRecording": 1785369600,
  "timeRecording": "23:54",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 115
 },
 {
  "url1": "1214165869",
  "url2": "af8a20b55a",
  "author": "Lightning Storm",
  "cityLocation": "Buenos Aires - Argentina",
  "Latitude": "-34.6095579",
  "Longitude": "-58.3887904",
  "Interiors": false,
  "Water": false,
  "Snow": false,
  "Animals": false,
  "DayVideo": false,
  "City": true,
  "Rain": false,
  "Nature": false,
  "Night": true,
  "dateRecording": 1740096000,
  "timeRecording": "21:18",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 116
 },
 {
  "url1": "1214294111",
  "url2": "01b2e05573",
  "author": "anjali",
  "cityLocation": "Lucknow - India",
  "Latitude": "26.8381000",
  "Longitude": "80.9346001",
  "Interiors": false,
  "Water": false,
  "Snow": false,
  "Animals": false,
  "DayVideo": false,
  "City": true,
  "Rain": false,
  "Nature": false,
  "Night": true,
  "dateRecording": 1785369600,
  "timeRecording": "19:30",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 117
 },
 {
  "url1": "1214353196",
  "url2": "a2a2801059",
  "author": "Christy",
  "cityLocation": "Moody, Alabama - USA",
  "Latitude": "33.5909365",
  "Longitude": "-86.4908168",
  "Interiors": false,
  "Water": false,
  "Snow": false,
  "Animals": false,
  "DayVideo": true,
  "City": false,
  "Rain": false,
  "Nature": true,
  "Night": false,
  "dateRecording": 1785369600,
  "timeRecording": "12:25",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 118
 },
 {
  "url1": "1214379299",
  "url2": "c39b9f7776",
  "author": "UTSW Lab",
  "cityLocation": "Dallas, Texas - USA",
  "Latitude": "32.7762719",
  "Longitude": "-96.7968559",
  "Interiors": false,
  "Water": false,
  "Snow": false,
  "Animals": false,
  "DayVideo": true,
  "City": true,
  "Rain": false,
  "Nature": false,
  "Night": false,
  "dateRecording": 1785369600,
  "timeRecording": "14:26",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 119
 },
 {
  "url1": "1214389238",
  "url2": "eceef47aec",
  "author": "Esme",
  "cityLocation": "New Mexico - USA",
  "Latitude": "34.5802074",
  "Longitude": "-105.9960470",
  "Interiors": false,
  "Water": false,
  "Snow": false,
  "Animals": false,
  "DayVideo": false,
  "City": true,
  "Rain": true,
  "Nature": false,
  "Night": false,
  "dateRecording": 1785196800,
  "timeRecording": "19:05",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 120
 },
 {
  "url1": "1214529489",
  "url2": "a9c86694b9",
  "author": "Old House Vintage",
  "cityLocation": "Banglore - India",
  "Latitude": "13.0240558",
  "Longitude": "77.6240521",
  "Interiors": false,
  "Water": false,
  "Snow": false,
  "Animals": false,
  "DayVideo": true,
  "City": true,
  "Rain": false,
  "Nature": true,
  "Night": false,
  "dateRecording": 1785456000,
  "timeRecording": "05:00",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 121
 },
 {
  "url1": "1214517789",
  "url2": "7d5a410de6",
  "author": "zielwolf",
  "cityLocation": "St. Albans, Melbourne - Australia",
  "Latitude": "-37.7445560",
  "Longitude": "144.7996864",
  "Interiors": false,
  "Water": false,
  "Snow": false,
  "Animals": false,
  "DayVideo": true,
  "City": true,
  "Rain": false,
  "Nature": true,
  "Night": false,
  "dateRecording": 1785456000,
  "timeRecording": "17:20",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 122
 },
 {
  "url1": "1214428211",
  "url2": "a2254de596",
  "author": "Lynn",
  "cityLocation": "Medina, Ohio - USA",
  "Latitude": "41.1000764",
  "Longitude": "-81.9382517",
  "Interiors": false,
  "Water": false,
  "Snow": false,
  "Animals": true,
  "DayVideo": true,
  "City": false,
  "Rain": false,
  "Nature": true,
  "Night": false,
  "dateRecording": 1785369600,
  "timeRecording": "10:40",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 123
 },
 {
  "url1": "1214416855",
  "url2": "e0b735e3bc",
  "author": "Creekview",
  "cityLocation": "Prescott, AZ - USA",
  "Latitude": "34.5399840",
  "Longitude": "-112.4688120",
  "Interiors": false,
  "Water": false,
  "Snow": false,
  "Animals": false,
  "DayVideo": true,
  "City": false,
  "Rain": false,
  "Nature": false,
  "Night": false,
  "dateRecording": 1777939200,
  "timeRecording": "15:50",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 124
 },
 {
  "url1": "1214564942",
  "url2": "18085ab214",
  "author": "Cool Afternoon",
  "cityLocation": "State Of Bahia - Brazil",
  "Latitude": "",
  "Longitude": "",
  "Interiors": false,
  "Water": false,
  "Snow": false,
  "Animals": false,
  "DayVideo": true,
  "City": false,
  "Rain": false,
  "Nature": true,
  "Night": false,
  "dateRecording": 1785456000,
  "timeRecording": "14:00",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 125
 },
 {
  "url1": "1214569145",
  "url2": "f4a4009f77",
  "author": "MJVega",
  "cityLocation": "Auxerre - France",
  "Latitude": "47.7961287",
  "Longitude": "3.5705790",
  "Interiors": false,
  "Water": false,
  "Snow": false,
  "Animals": false,
  "DayVideo": false,
  "City": true,
  "Rain": false,
  "Nature": false,
  "Night": true,
  "dateRecording": 1785369600,
  "timeRecording": "21:58",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 126
 },
 {
  "url1": "1214586413",
  "url2": "7097bcadd3",
  "author": "Countryside ",
  "cityLocation": "Ozzano Taro - Italy",
  "Latitude": "44.7098232",
  "Longitude": "10.1430765",
  "Interiors": false,
  "Water": false,
  "Snow": false,
  "Animals": false,
  "DayVideo": true,
  "City": false,
  "Rain": false,
  "Nature": true,
  "Night": false,
  "dateRecording": 1785456000,
  "timeRecording": "09:20",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 127
 },
 {
  "url1": "1214587267",
  "url2": "929865ab40",
  "author": "Countryside",
  "cityLocation": "Ozzano Taro - Italy",
  "Latitude": "44.7098232",
  "Longitude": "10.1430765",
  "Interiors": false,
  "Water": false,
  "Snow": false,
  "Animals": false,
  "DayVideo": false,
  "City": false,
  "Rain": false,
  "Nature": false,
  "Night": false,
  "dateRecording": 1785456000,
  "timeRecording": "09:40",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 128
 },
 {
  "url1": "1214828472",
  "url2": "9c0d541504",
  "author": "Gallan",
  "cityLocation": "Anola, Manitoba - Canada",
  "Latitude": "49.8852225",
  "Longitude": "-96.6370639",
  "Interiors": false,
  "Water": false,
  "Snow": false,
  "Animals": false,
  "DayVideo": false,
  "City": false,
  "Rain": false,
  "Nature": true,
  "Night": false,
  "dateRecording": 1785542400,
  "timeRecording": "09:10",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 129
 },
 {
  "url1": "1214620917",
  "url2": "bf3ac3eddc",
  "author": "Beach Sunset",
  "cityLocation": "Lisbon - Portugal",
  "Latitude": "38.7077507",
  "Longitude": "-9.1365919",
  "Interiors": false,
  "Water": true,
  "Snow": false,
  "Animals": false,
  "DayVideo": true,
  "City": false,
  "Rain": false,
  "Nature": true,
  "Night": false,
  "dateRecording": 1785110400,
  "timeRecording": "20:08",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 130
 },
 {
  "url1": "1214615491",
  "url2": "8e03d5cfdb",
  "author": "Croydon",
  "cityLocation": "Shirley croydon - UK",
  "Latitude": "51.3749243",
  "Longitude": "-0.0466335",
  "Interiors": false,
  "Water": false,
  "Snow": false,
  "Animals": false,
  "DayVideo": true,
  "City": true,
  "Rain": false,
  "Nature": false,
  "Night": false,
  "dateRecording": 1785456000,
  "timeRecording": "03:43",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 131
 },
 {
  "url1": "1214601818",
  "url2": "ebe22d36c9",
  "author": "Raven",
  "cityLocation": "Lincolnshire Fens - UK",
  "Latitude": "",
  "Longitude": "",
  "Interiors": false,
  "Water": false,
  "Snow": false,
  "Animals": false,
  "DayVideo": true,
  "City": false,
  "Rain": false,
  "Nature": true,
  "Night": false,
  "dateRecording": 1785456000,
  "timeRecording": "14:50",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 132
 },
 {
  "url1": "1214845382",
  "url2": "0a0a56bb78",
  "author": "View from home",
  "cityLocation": "Edmonton - Canada",
  "Latitude": "53.5462055",
  "Longitude": "-113.4912410",
  "Interiors": false,
  "Water": false,
  "Snow": false,
  "Animals": false,
  "DayVideo": true,
  "City": true,
  "Rain": false,
  "Nature": false,
  "Night": false,
  "dateRecording": 1785542400,
  "timeRecording": "10:26",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 133
 },
 {
  "url1": "1214869922",
  "url2": "6b57ba8fca",
  "author": "Night Outside",
  "cityLocation": "Kazan - Russia",
  "Latitude": "55.7946485",
  "Longitude": "49.1115022",
  "Interiors": false,
  "Water": false,
  "Snow": false,
  "Animals": false,
  "DayVideo": false,
  "City": true,
  "Rain": false,
  "Nature": false,
  "Night": true,
  "dateRecording": 1785542400,
  "timeRecording": "23:15",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 134
 },
 {
  "url1": "1214875015",
  "url2": "4a25518e12",
  "author": "Gallan",
  "cityLocation": "Anola, Manitoba - Canada",
  "Latitude": "49.8852225",
  "Longitude": "-96.6370639",
  "Interiors": false,
  "Water": false,
  "Snow": false,
  "Animals": true,
  "DayVideo": false,
  "City": false,
  "Rain": false,
  "Nature": false,
  "Night": false,
  "dateRecording": 1785456000,
  "timeRecording": "16:00",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 135
 },
 {
  "url1": "1214937043",
  "url2": "ea4cb98e99",
  "author": "Judith",
  "cityLocation": "Cloughey, Co. Down - Ireland",
  "Latitude": "54.4283218",
  "Longitude": "-5.4809287",
  "Interiors": false,
  "Water": false,
  "Snow": false,
  "Animals": true,
  "DayVideo": false,
  "City": false,
  "Rain": false,
  "Nature": true,
  "Night": false,
  "dateRecording": 1785628800,
  "timeRecording": "09:55",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 136
 },
 {
  "url1": "1215009518",
  "url2": "03dc1cfb24",
  "author": "Fetty Yeti",
  "cityLocation": "Fort Worth, TX - USA",
  "Latitude": "32.7531770",
  "Longitude": "-97.3327459",
  "Interiors": false,
  "Water": false,
  "Snow": false,
  "Animals": false,
  "DayVideo": true,
  "City": false,
  "Rain": false,
  "Nature": true,
  "Night": false,
  "dateRecording": 1785542400,
  "timeRecording": "14:20",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 137
 },
 {
  "url1": "1214967433",
  "url2": "7f0ff210d4",
  "author": "Isabel",
  "cityLocation": "Marina del Este, Granada - Spain",
  "Latitude": "36.7274475",
  "Longitude": "-3.7275317",
  "Interiors": false,
  "Water": true,
  "Snow": false,
  "Animals": false,
  "DayVideo": true,
  "City": false,
  "Rain": false,
  "Nature": true,
  "Night": false,
  "dateRecording": 1785196800,
  "timeRecording": "15:00",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 138
 },
 {
  "url1": "1214962810",
  "url2": "8ef63360f9",
  "author": "pigeon view",
  "cityLocation": "Maastricht - Netherlands",
  "Latitude": "50.8512438",
  "Longitude": "5.6909768",
  "Interiors": false,
  "Water": false,
  "Snow": false,
  "Animals": false,
  "DayVideo": true,
  "City": false,
  "Rain": false,
  "Nature": true,
  "Night": false,
  "dateRecording": 1785542400,
  "timeRecording": "21:40",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 139
 },
 {
  "url1": "1214955648",
  "url2": "c981698f22",
  "author": "Anwi",
  "cityLocation": "Maharashtra - India",
  "Latitude": "18.9068356",
  "Longitude": "75.6741579",
  "Interiors": false,
  "Water": false,
  "Snow": false,
  "Animals": false,
  "DayVideo": true,
  "City": true,
  "Rain": false,
  "Nature": true,
  "Night": false,
  "dateRecording": 1785628800,
  "timeRecording": "18:15",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 140
 },
 {
  "url1": "1215051616",
  "url2": "5099efb391",
  "author": "Fetty Yeti",
  "cityLocation": "Fort Worth Texas - USA",
  "Latitude": "32.9798431",
  "Longitude": "-97.3091928",
  "Interiors": false,
  "Water": false,
  "Snow": false,
  "Animals": true,
  "DayVideo": false,
  "City": false,
  "Rain": false,
  "Nature": true,
  "Night": false,
  "dateRecording": 1785628800,
  "timeRecording": "20:00",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 141
 },
 {
  "url1": "1215143881",
  "url2": "606a246699",
  "author": "Day in Budva",
  "cityLocation": "Budva - Montenegro",
  "Latitude": "42.2885656",
  "Longitude": "18.8419505",
  "Interiors": false,
  "Water": false,
  "Snow": false,
  "Animals": false,
  "DayVideo": true,
  "City": true,
  "Rain": false,
  "Nature": false,
  "Night": false,
  "dateRecording": 1785715200,
  "timeRecording": "12:00",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 142
 },
 {
  "url1": "1215178317",
  "url2": "b442e68b3c",
  "author": "Brazil Somewhere",
  "cityLocation": "Navegantes - Brasil",
  "Latitude": "-26.8898813",
  "Longitude": "-48.6495828",
  "Interiors": true,
  "Water": false,
  "Snow": false,
  "Animals": false,
  "DayVideo": true,
  "City": false,
  "Rain": false,
  "Nature": true,
  "Night": false,
  "dateRecording": 1785715200,
  "timeRecording": "10:15",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 143
 },
 {
  "url1": "1215185557",
  "url2": "98665c61ee",
  "author": "Outskirts of Idalion",
  "cityLocation": "Nicosia - Cyprus",
  "Latitude": "35.1746503",
  "Longitude": "33.3638783",
  "Interiors": false,
  "Water": false,
  "Snow": false,
  "Animals": false,
  "DayVideo": true,
  "City": false,
  "Rain": false,
  "Nature": false,
  "Night": false,
  "dateRecording": 1785715200,
  "timeRecording": "16:20",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 144
 },
 {
  "url1": "1215430977",
  "url2": "b66e3e15b2",
  "author": "Olga",
  "cityLocation": "Ереван - Армения",
  "Latitude": "40.1777112",
  "Longitude": "44.5126233",
  "Interiors": false,
  "Water": false,
  "Snow": false,
  "Animals": false,
  "DayVideo": true,
  "City": false,
  "Rain": false,
  "Nature": false,
  "Night": false,
  "dateRecording": 1785110400,
  "timeRecording": "12:40",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 145
 },
 {
  "url1": "1215420362",
  "url2": "f65961b9cc",
  "author": "summer valley",
  "cityLocation": "Latsia - Cyprus",
  "Latitude": "35.0995648",
  "Longitude": "33.3815988",
  "Interiors": false,
  "Water": false,
  "Snow": false,
  "Animals": false,
  "DayVideo": false,
  "City": false,
  "Rain": false,
  "Nature": true,
  "Night": false,
  "dateRecording": -61328102400,
  "timeRecording": "11:06",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 146
 },
 {
  "url1": "1215408796",
  "url2": "a688916f96",
  "author": "Jef_Costello",
  "cityLocation": "Melbourne - Australia",
  "Latitude": "-37.8142454",
  "Longitude": "144.9631732",
  "Interiors": false,
  "Water": false,
  "Snow": false,
  "Animals": false,
  "DayVideo": false,
  "City": true,
  "Rain": true,
  "Nature": false,
  "Night": false,
  "dateRecording": 1785801600,
  "timeRecording": "17:45",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 147
 },
 {
  "url1": "1215299541",
  "url2": "cd76e178c3",
  "author": "Beth",
  "cityLocation": "Central Pennsylvania - USA",
  "Latitude": "40.6269819",
  "Longitude": "-75.3615144",
  "Interiors": false,
  "Water": false,
  "Snow": false,
  "Animals": false,
  "DayVideo": true,
  "City": false,
  "Rain": false,
  "Nature": true,
  "Night": false,
  "dateRecording": 1785715200,
  "timeRecording": "16:45",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 148
 },
 {
  "url1": "1215585697",
  "url2": "7b0c6ceab1",
  "author": "Airport",
  "cityLocation": "Prague  - Czechia",
  "Latitude": "50.0596288",
  "Longitude": "14.4464593",
  "Interiors": false,
  "Water": false,
  "Snow": false,
  "Animals": false,
  "DayVideo": true,
  "City": false,
  "Rain": false,
  "Nature": false,
  "Night": false,
  "dateRecording": 1785801600,
  "timeRecording": "20:35",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 149
 },
 {
  "url1": "1215603218",
  "url2": "4d018f28f0",
  "author": "Cinnamon_whisper",
  "cityLocation": "Bavaria - Germany",
  "Latitude": "48.9467562",
  "Longitude": "11.4038717",
  "Interiors": false,
  "Water": false,
  "Snow": false,
  "Animals": false,
  "DayVideo": false,
  "City": false,
  "Rain": false,
  "Nature": true,
  "Night": true,
  "dateRecording": 1785801600,
  "timeRecording": "22:00",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 150
 },
 {
  "url1": "1215725551",
  "url2": "362e41ae15",
  "author": "Sunrise",
  "cityLocation": "Port Moresby - Papua New Guinea",
  "Latitude": "-9.4743301",
  "Longitude": "147.1599504",
  "Interiors": false,
  "Water": false,
  "Snow": false,
  "Animals": false,
  "DayVideo": true,
  "City": true,
  "Rain": false,
  "Nature": false,
  "Night": false,
  "dateRecording": 1785715200,
  "timeRecording": "06:10",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 151
 },
 {
  "url1": "1215726686",
  "url2": "40c5b0c5b1",
  "author": "Portu",
  "cityLocation": "Asturias - Spain",
  "Latitude": "43.3133868",
  "Longitude": "-5.9419200",
  "Interiors": false,
  "Water": false,
  "Snow": false,
  "Animals": false,
  "DayVideo": false,
  "City": false,
  "Rain": false,
  "Nature": true,
  "Night": false,
  "dateRecording": 1785888000,
  "timeRecording": "10:55",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 152
 },
 {
  "url1": "1215868969",
  "url2": "4ecc4b640f",
  "author": "Bosquet",
  "cityLocation": "Parets del Vallès - Spain",
  "Latitude": "41.5729887",
  "Longitude": "2.2329289",
  "Interiors": false,
  "Water": false,
  "Snow": false,
  "Animals": false,
  "DayVideo": true,
  "City": false,
  "Rain": false,
  "Nature": false,
  "Night": false,
  "dateRecording": 1785888000,
  "timeRecording": "00:10",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 153
 },
 {
  "url1": "1215845927",
  "url2": "b677aed0c0",
  "author": "Work",
  "cityLocation": "Quito - Ecuador",
  "Latitude": "-0.2201641",
  "Longitude": "-78.5123274",
  "Interiors": false,
  "Water": false,
  "Snow": false,
  "Animals": false,
  "DayVideo": true,
  "City": true,
  "Rain": false,
  "Nature": false,
  "Night": false,
  "dateRecording": 1785888000,
  "timeRecording": "10:28",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 154
 },
 {
  "url1": "1215818783",
  "url2": "9c07365c8d",
  "author": "Almaty",
  "cityLocation": "Almaty - Kazakhstan",
  "Latitude": "43.2363924",
  "Longitude": "76.9457275",
  "Interiors": false,
  "Water": false,
  "Snow": false,
  "Animals": false,
  "DayVideo": true,
  "City": true,
  "Rain": true,
  "Nature": true,
  "Night": false,
  "dateRecording": 1785888000,
  "timeRecording": "19:20",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 155
 },
 {
  "url1": "1215745405",
  "url2": "453643dc10",
  "author": "UnPij",
  "cityLocation": "Crivina, Prahova - Romania",
  "Latitude": "44.7863565",
  "Longitude": "26.0560415",
  "Interiors": false,
  "Water": false,
  "Snow": false,
  "Animals": false,
  "DayVideo": true,
  "City": false,
  "Rain": false,
  "Nature": true,
  "Night": false,
  "dateRecording": 1785888000,
  "timeRecording": "07:11",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 156
 },
 {
  "url1": "1215873749",
  "url2": "01518482c4",
  "author": "Plane tree alley",
  "cityLocation": "Barcelona - Spain",
  "Latitude": "41.3825802",
  "Longitude": "2.1770730",
  "Interiors": false,
  "Water": false,
  "Snow": false,
  "Animals": false,
  "DayVideo": true,
  "City": true,
  "Rain": false,
  "Nature": false,
  "Night": false,
  "dateRecording": 1785888000,
  "timeRecording": "19:22",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 157
 },
 {
  "url1": "1215881827",
  "url2": "91eaa045f8",
  "author": "Sílvia",
  "cityLocation": "Charneca da Caparica - Portugal",
  "Latitude": "38.6285507",
  "Longitude": "-9.1974387",
  "Interiors": false,
  "Water": false,
  "Snow": false,
  "Animals": false,
  "DayVideo": true,
  "City": true,
  "Rain": false,
  "Nature": false,
  "Night": false,
  "dateRecording": 1785628800,
  "timeRecording": "10:35PM",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 158
 },
 {
  "url1": "1215908566",
  "url2": "e879a0fded",
  "author": "GapToothedGypsy",
  "cityLocation": "Isle of Man - UK",
  "Latitude": "55.0631283",
  "Longitude": "-3.5557468",
  "Interiors": true,
  "Water": false,
  "Snow": false,
  "Animals": false,
  "DayVideo": false,
  "City": false,
  "Rain": false,
  "Nature": false,
  "Night": false,
  "dateRecording": 1785888000,
  "timeRecording": "15:00",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 159
 },
 {
  "url1": "1215923615",
  "url2": "75ad9d8ec0",
  "author": "Allisters Hastings",
  "cityLocation": "Srijani - India",
  "Latitude": "23.6718458",
  "Longitude": "87.6683106",
  "Interiors": false,
  "Water": false,
  "Snow": false,
  "Animals": false,
  "DayVideo": true,
  "City": true,
  "Rain": true,
  "Nature": false,
  "Night": false,
  "dateRecording": 1784505600,
  "timeRecording": "15:11",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 160
 },
 {
  "url1": "1216139121",
  "url2": "05b9511897",
  "author": "Eleonira",
  "cityLocation": "Pavia - Italy",
  "Latitude": "45.0368546",
  "Longitude": "9.1378251",
  "Interiors": false,
  "Water": false,
  "Snow": false,
  "Animals": false,
  "DayVideo": true,
  "City": true,
  "Rain": false,
  "Nature": false,
  "Night": false,
  "dateRecording": 1785974400,
  "timeRecording": "15:52",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 161
 },
 {
  "url1": "1216061173",
  "url2": "ef822efdad",
  "author": "Harshj0003",
  "cityLocation": "Korba, Chattisgarh - India",
  "Latitude": "22.5198217",
  "Longitude": "82.6350029",
  "Interiors": false,
  "Water": false,
  "Snow": false,
  "Animals": false,
  "DayVideo": true,
  "City": false,
  "Rain": true,
  "Nature": true,
  "Night": false,
  "dateRecording": 1785974400,
  "timeRecording": "10:30",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 162
 },
 {
  "url1": "1215945517",
  "url2": "ee97779750",
  "author": "Carol",
  "cityLocation": "Montclair, VA - USA",
  "Latitude": "38.6076755",
  "Longitude": "-77.3331006",
  "Interiors": false,
  "Water": false,
  "Snow": false,
  "Animals": true,
  "DayVideo": true,
  "City": false,
  "Rain": false,
  "Nature": true,
  "Night": false,
  "dateRecording": 1785888000,
  "timeRecording": "14:52",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 163
 },
 {
  "url1": "1215943181",
  "url2": "1f96464890",
  "author": "Claudio",
  "cityLocation": "Villarrica - Chile",
  "Latitude": "-39.2780911",
  "Longitude": "-72.2274364",
  "Interiors": false,
  "Water": false,
  "Snow": false,
  "Animals": false,
  "DayVideo": true,
  "City": false,
  "Rain": false,
  "Nature": true,
  "Night": true,
  "dateRecording": 1785888000,
  "timeRecording": "18:06",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 164
 },
 {
  "url1": "1216153863",
  "url2": "3a008ebbe5",
  "author": "JK",
  "cityLocation": "Houston, Texas - USA",
  "Latitude": "29.7589382",
  "Longitude": "-95.3676974",
  "Interiors": false,
  "Water": true,
  "Snow": false,
  "Animals": false,
  "DayVideo": true,
  "City": false,
  "Rain": false,
  "Nature": true,
  "Night": false,
  "dateRecording": 1785974400,
  "timeRecording": "09:05",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 165
 },
 {
  "url1": "1216223014",
  "url2": "88eb0f51ef",
  "author": "My Sky",
  "cityLocation": "Moscow - Russia",
  "Latitude": "55.6255780",
  "Longitude": "37.6063916",
  "Interiors": false,
  "Water": false,
  "Snow": false,
  "Animals": false,
  "DayVideo": true,
  "City": true,
  "Rain": false,
  "Nature": false,
  "Night": true,
  "dateRecording": 1785974400,
  "timeRecording": "20:03",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 166
 },
 {
  "url1": "1216340520",
  "url2": "8591ac19ba",
  "author": "DJ Eindhoven",
  "cityLocation": "Eindhoven - Netherlands",
  "Latitude": "51.4392648",
  "Longitude": "5.4786330",
  "Interiors": false,
  "Water": true,
  "Snow": false,
  "Animals": false,
  "DayVideo": true,
  "City": false,
  "Rain": false,
  "Nature": true,
  "Night": false,
  "dateRecording": 1786060800,
  "timeRecording": "07:30",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 167
 },
 {
  "url1": "1216371936",
  "url2": "2226aeb4da",
  "author": "Shaikh Sufiyan",
  "cityLocation": "Maharashtra Nandurbar - India",
  "Latitude": "21.5641134",
  "Longitude": "74.2184769",
  "Interiors": false,
  "Water": false,
  "Snow": false,
  "Animals": false,
  "DayVideo": false,
  "City": true,
  "Rain": false,
  "Nature": true,
  "Night": false,
  "dateRecording": 1786060800,
  "timeRecording": "15:26",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 168
 },
 {
  "url1": "1216617823",
  "url2": "713bf07b42",
  "author": "Taidesaari",
  "cityLocation": "Vaajakoski - Finland",
  "Latitude": "62.2479788",
  "Longitude": "25.8626953",
  "Interiors": false,
  "Water": false,
  "Snow": false,
  "Animals": false,
  "DayVideo": false,
  "City": true,
  "Rain": false,
  "Nature": false,
  "Night": false,
  "dateRecording": 1786147200,
  "timeRecording": "11:52",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 169
 },
 {
  "url1": "1216607543",
  "url2": "ae9e5f7284",
  "author": "Adtronomical Clock",
  "cityLocation": "Prague - Czechia",
  "Latitude": "50.0596288",
  "Longitude": "14.4464593",
  "Interiors": false,
  "Water": false,
  "Snow": false,
  "Animals": false,
  "DayVideo": true,
  "City": true,
  "Rain": false,
  "Nature": false,
  "Night": false,
  "dateRecording": 1785888000,
  "timeRecording": "11:06",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 170
 },
 {
  "url1": "1216601772",
  "url2": "0bb842863d",
  "author": "Tarçınhome",
  "cityLocation": "Eskişehir - Türkiye",
  "Latitude": "39.7743941",
  "Longitude": "30.5191160",
  "Interiors": false,
  "Water": false,
  "Snow": true,
  "Animals": true,
  "DayVideo": true,
  "City": true,
  "Rain": true,
  "Nature": true,
  "Night": false,
  "dateRecording": 1786147200,
  "timeRecording": "09:13",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 171
 },
 {
  "url1": "1216438857",
  "url2": "6c7c75900f",
  "author": "iNKSTECHSHUB",
  "cityLocation": "Rio - Argentina",
  "Latitude": "-29.4385930",
  "Longitude": "-66.8828408",
  "Interiors": false,
  "Water": false,
  "Snow": false,
  "Animals": true,
  "DayVideo": false,
  "City": false,
  "Rain": false,
  "Nature": true,
  "Night": false,
  "dateRecording": 1786060800,
  "timeRecording": "18:47",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 172
 },
 {
  "url1": "1216657448",
  "url2": "6a496cfdc9",
  "author": "DowagerLadyUrsula",
  "cityLocation": "St Charles, Illinois - USA",
  "Latitude": "41.9139808",
  "Longitude": "-88.3128183",
  "Interiors": false,
  "Water": false,
  "Snow": false,
  "Animals": false,
  "DayVideo": true,
  "City": false,
  "Rain": false,
  "Nature": false,
  "Night": false,
  "dateRecording": 1785974400,
  "timeRecording": "10:35PM",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 173
 },
 {
  "url1": "1216659395",
  "url2": "41e9ab4778",
  "author": "EF2020's Bedroom",
  "cityLocation": "Camp 7, Baguio City - Philippines",
  "Latitude": "16.3821151",
  "Longitude": "120.6048225",
  "Interiors": true,
  "Water": false,
  "Snow": false,
  "Animals": false,
  "DayVideo": true,
  "City": false,
  "Rain": false,
  "Nature": false,
  "Night": false,
  "dateRecording": 1784332800,
  "timeRecording": "15:18",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 174
 },
 {
  "url1": "1216664681",
  "url2": "a11d7e0c08",
  "author": "EF2020's Balcony",
  "cityLocation": "Camp 7, Baguio City - Philippines",
  "Latitude": "16.3821151",
  "Longitude": "120.6048225",
  "Interiors": true,
  "Water": false,
  "Snow": false,
  "Animals": false,
  "DayVideo": false,
  "City": true,
  "Rain": true,
  "Nature": false,
  "Night": false,
  "dateRecording": 1783209600,
  "timeRecording": "18:07",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 175
 },
 {
  "url1": "1216670962",
  "url2": "37ae5e9120",
  "author": "Jardim",
  "cityLocation": "Viseu - Portugal",
  "Latitude": "40.6574713",
  "Longitude": "-7.9138664",
  "Interiors": false,
  "Water": false,
  "Snow": false,
  "Animals": true,
  "DayVideo": true,
  "City": false,
  "Rain": false,
  "Nature": true,
  "Night": false,
  "dateRecording": 1785715200,
  "timeRecording": "19:44",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 176
 },
 {
  "url1": "1216745247",
  "url2": "105dc888b4",
  "author": "Golvellius",
  "cityLocation": "Sada (A Coruña) - Spain",
  "Latitude": "43.3515799",
  "Longitude": "-8.2534683",
  "Interiors": false,
  "Water": false,
  "Snow": false,
  "Animals": true,
  "DayVideo": true,
  "City": false,
  "Rain": false,
  "Nature": true,
  "Night": false,
  "dateRecording": 1786233600,
  "timeRecording": "08:32",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 177
 },
 {
  "url1": "1216726855",
  "url2": "8d44623069",
  "author": "Amedyr",
  "cityLocation": "Botucatu, São Paulo - Brazil",
  "Latitude": "-22.8879628",
  "Longitude": "-48.4410712",
  "Interiors": false,
  "Water": false,
  "Snow": false,
  "Animals": false,
  "DayVideo": true,
  "City": true,
  "Rain": false,
  "Nature": true,
  "Night": false,
  "dateRecording": 1785974400,
  "timeRecording": "15:42",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 178
 },
 {
  "url1": "1216719530",
  "url2": "413be8cb4d",
  "author": "Fortune",
  "cityLocation": "Washington - USA",
  "Latitude": "38.8950368",
  "Longitude": "-77.0365427",
  "Interiors": false,
  "Water": false,
  "Snow": false,
  "Animals": false,
  "DayVideo": true,
  "City": false,
  "Rain": false,
  "Nature": false,
  "Night": false,
  "dateRecording": 1786147200,
  "timeRecording": "17:20",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 179
 },
 {
  "url1": "1216718040",
  "url2": "7402a386fe",
  "author": "crystal quiet morning",
  "cityLocation": "Buenos Aires - Argentina",
  "Latitude": "-34.6095579",
  "Longitude": "-58.3887904",
  "Interiors": false,
  "Water": false,
  "Snow": false,
  "Animals": false,
  "DayVideo": true,
  "City": true,
  "Rain": false,
  "Nature": false,
  "Night": false,
  "dateRecording": 1785110400,
  "timeRecording": "10:35PM",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 180
 },
 {
  "url1": "1216745556",
  "url2": "19804f0f8c",
  "author": "Just my window",
  "cityLocation": "Ranchi - India",
  "Latitude": "23.3700501",
  "Longitude": "85.3250387",
  "Interiors": false,
  "Water": false,
  "Snow": false,
  "Animals": false,
  "DayVideo": true,
  "City": false,
  "Rain": false,
  "Nature": true,
  "Night": false,
  "dateRecording": 1786233600,
  "timeRecording": "12:03",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 181
 },
 {
  "url1": "1216779950",
  "url2": "59987c0d4c",
  "author": "Nick",
  "cityLocation": "Athens - Greece",
  "Latitude": "37.9755648",
  "Longitude": "23.7348324",
  "Interiors": false,
  "Water": false,
  "Snow": false,
  "Animals": false,
  "DayVideo": true,
  "City": true,
  "Rain": false,
  "Nature": false,
  "Night": false,
  "dateRecording": 1786233600,
  "timeRecording": "15:35",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 182
 },
 {
  "url1": "1216782169",
  "url2": "6b536cbf40",
  "author": "Ferrious",
  "cityLocation": "Bhubneswar - India",
  "Latitude": "",
  "Longitude": "",
  "Interiors": false,
  "Water": false,
  "Snow": false,
  "Animals": false,
  "DayVideo": true,
  "City": true,
  "Rain": false,
  "Nature": false,
  "Night": true,
  "dateRecording": 1786233600,
  "timeRecording": "18:33",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 183
 },
 {
  "url1": "1216808695",
  "url2": "b795dca006",
  "author": "Manaós",
  "cityLocation": "Manaus-Amazonas - Brasil",
  "Latitude": "1.3803908",
  "Longitude": "-67.1192987",
  "Interiors": false,
  "Water": false,
  "Snow": false,
  "Animals": false,
  "DayVideo": true,
  "City": true,
  "Rain": false,
  "Nature": false,
  "Night": false,
  "dateRecording": 1786233600,
  "timeRecording": "12:46",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 184
 },
 {
  "url1": "1217056861",
  "url2": "5ec04883a3",
  "author": "Maishu",
  "cityLocation": "Dinajpur - Bangladesh",
  "Latitude": "25.6260712",
  "Longitude": "88.6346228",
  "Interiors": false,
  "Water": false,
  "Snow": false,
  "Animals": false,
  "DayVideo": true,
  "City": false,
  "Rain": true,
  "Nature": true,
  "Night": false,
  "dateRecording": 1786320000,
  "timeRecording": "16:40",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 185
 },
 {
  "url1": "1216849962",
  "url2": "ac1631ade7",
  "author": "EF2020's Balcony",
  "cityLocation": "Camp 7, Baguio City - Philippines",
  "Latitude": "16.3821151",
  "Longitude": "120.6048225",
  "Interiors": false,
  "Water": false,
  "Snow": false,
  "Animals": false,
  "DayVideo": true,
  "City": false,
  "Rain": true,
  "Nature": true,
  "Night": false,
  "dateRecording": 1786233600,
  "timeRecording": "11:48",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 186
 },
 {
  "url1": "1216842213",
  "url2": "247859987a",
  "author": "Kirinha",
  "cityLocation": "Madrid - Spain",
  "Latitude": "40.4167820",
  "Longitude": "-3.7035070",
  "Interiors": true,
  "Water": false,
  "Snow": false,
  "Animals": true,
  "DayVideo": true,
  "City": true,
  "Rain": false,
  "Nature": false,
  "Night": false,
  "dateRecording": 1786147200,
  "timeRecording": "19:07",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 187
 },
 {
  "url1": "1216810858",
  "url2": "5e172c1e7c",
  "author": "Suburban Garden",
  "cityLocation": "Winchmore Hill - UK",
  "Latitude": "51.6333948",
  "Longitude": "-0.1033617",
  "Interiors": false,
  "Water": false,
  "Snow": false,
  "Animals": false,
  "DayVideo": true,
  "City": false,
  "Rain": false,
  "Nature": false,
  "Night": false,
  "dateRecording": 1786233600,
  "timeRecording": "17:30",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 188
 },
 {
  "url1": "1217060148",
  "url2": "849349a78a",
  "author": "E",
  "cityLocation": "Istanbul - Turkey",
  "Latitude": "41.0063810",
  "Longitude": "28.9758715",
  "Interiors": false,
  "Water": true,
  "Snow": false,
  "Animals": false,
  "DayVideo": false,
  "City": false,
  "Rain": false,
  "Nature": true,
  "Night": false,
  "dateRecording": 1786320000,
  "timeRecording": "19:56",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 189
 },
 {
  "url1": "1217087489",
  "url2": "92d2d2bbd2",
  "author": "Window Pane",
  "cityLocation": "Katy, TX - USA",
  "Latitude": "29.7857853",
  "Longitude": "-95.8243956",
  "Interiors": false,
  "Water": false,
  "Snow": false,
  "Animals": false,
  "DayVideo": false,
  "City": true,
  "Rain": false,
  "Nature": true,
  "Night": false,
  "dateRecording": 1786233600,
  "timeRecording": "13:00",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 190
 },
 {
  "url1": "1217090189",
  "url2": "5b60db2073",
  "author": "Lucy",
  "cityLocation": "Carnoustie, Scotland - UK",
  "Latitude": "56.5010506",
  "Longitude": "-2.7114030",
  "Interiors": false,
  "Water": true,
  "Snow": false,
  "Animals": false,
  "DayVideo": false,
  "City": false,
  "Rain": false,
  "Nature": true,
  "Night": false,
  "dateRecording": 1786320000,
  "timeRecording": "18:11",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 191
 },
 {
  "url1": "1217094701",
  "url2": "772217f6ba",
  "author": "Monaline",
  "cityLocation": "Antwerpen - Belgium",
  "Latitude": "51.2211097",
  "Longitude": "4.3997081",
  "Interiors": false,
  "Water": false,
  "Snow": false,
  "Animals": false,
  "DayVideo": true,
  "City": true,
  "Rain": false,
  "Nature": false,
  "Night": false,
  "dateRecording": 1786320000,
  "timeRecording": "20:32",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 192
 },
 {
  "url1": "1217162916",
  "url2": "e4f0d70d17",
  "author": "Hummingbirds",
  "cityLocation": "Prague Oklahoma - USA",
  "Latitude": "35.4866036",
  "Longitude": "-96.6858998",
  "Interiors": false,
  "Water": false,
  "Snow": false,
  "Animals": true,
  "DayVideo": true,
  "City": false,
  "Rain": false,
  "Nature": true,
  "Night": false,
  "dateRecording": 1786320000,
  "timeRecording": "10:35PM",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 193
 },
 {
  "url1": "1217145898",
  "url2": "8d46623b71",
  "author": "ElCorcheasZgz",
  "cityLocation": "Zaragoza - Spain",
  "Latitude": "41.6521342",
  "Longitude": "-0.8809428",
  "Interiors": false,
  "Water": false,
  "Snow": false,
  "Animals": false,
  "DayVideo": false,
  "City": true,
  "Rain": false,
  "Nature": false,
  "Night": true,
  "dateRecording": 1786406400,
  "timeRecording": "10:02",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 194
 },
 {
  "url1": "1217122102",
  "url2": "7d0e6a7074",
  "author": "W",
  "cityLocation": "Bundang - South Korea",
  "Latitude": "37.3777369",
  "Longitude": "127.1238612",
  "Interiors": false,
  "Water": false,
  "Snow": false,
  "Animals": false,
  "DayVideo": false,
  "City": true,
  "Rain": false,
  "Nature": false,
  "Night": true,
  "dateRecording": 1785628800,
  "timeRecording": "20:09",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 195
 },
 {
  "url1": "1217118811",
  "url2": "da83d1ce6e",
  "author": "W",
  "cityLocation": "Bundang - South Korea",
  "Latitude": "37.3777369",
  "Longitude": "127.1238612",
  "Interiors": false,
  "Water": false,
  "Snow": false,
  "Animals": false,
  "DayVideo": true,
  "City": true,
  "Rain": false,
  "Nature": false,
  "Night": false,
  "dateRecording": 1786320000,
  "timeRecording": "05:48",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 196
 },
 {
  "url1": "1217238950",
  "url2": "bf5bb670f7",
  "author": "Ali",
  "cityLocation": "Brebu - Romania",
  "Latitude": "45.4197556",
  "Longitude": "21.9914100",
  "Interiors": false,
  "Water": false,
  "Snow": false,
  "Animals": false,
  "DayVideo": true,
  "City": false,
  "Rain": false,
  "Nature": true,
  "Night": false,
  "dateRecording": 1786406400,
  "timeRecording": "10:30",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 197
 },
 {
  "url1": "1217243402",
  "url2": "8f1afd2067",
  "author": "Jeff",
  "cityLocation": "Leeds - UK",
  "Latitude": "53.7974185",
  "Longitude": "-1.5437941",
  "Interiors": false,
  "Water": false,
  "Snow": false,
  "Animals": false,
  "DayVideo": true,
  "City": true,
  "Rain": false,
  "Nature": false,
  "Night": false,
  "dateRecording": 1786406400,
  "timeRecording": "09:14",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 198
 },
 {
  "url1": "1217253387",
  "url2": "e16f74d673",
  "author": "Garden in a waking sun",
  "cityLocation": "Bilthoven - Netherlands",
  "Latitude": "52.1289693",
  "Longitude": "5.2046134",
  "Interiors": false,
  "Water": false,
  "Snow": false,
  "Animals": false,
  "DayVideo": true,
  "City": false,
  "Rain": false,
  "Nature": true,
  "Night": false,
  "dateRecording": 1786406400,
  "timeRecording": "09:15",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 199
 },
 {
  "url1": "1217270341",
  "url2": "96ed2107e0",
  "author": "Sebastian",
  "cityLocation": "Ludwigsburg - Germany",
  "Latitude": "48.8953937",
  "Longitude": "9.1895147",
  "Interiors": false,
  "Water": false,
  "Snow": false,
  "Animals": false,
  "DayVideo": true,
  "City": true,
  "Rain": false,
  "Nature": true,
  "Night": false,
  "dateRecording": 1786406400,
  "timeRecording": "10:45",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 200
 },
 {
  "url1": "1217412168",
  "url2": "d5515bb45e",
  "author": "Landscape neighborhood",
  "cityLocation": "Istanbul - Turkey",
  "Latitude": "41.0063810",
  "Longitude": "28.9758715",
  "Interiors": false,
  "Water": false,
  "Snow": false,
  "Animals": false,
  "DayVideo": true,
  "City": true,
  "Rain": false,
  "Nature": false,
  "Night": false,
  "dateRecording": 1786406400,
  "timeRecording": "18:18",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 201
 },
 {
  "url1": "1217401126",
  "url2": "6895a57992",
  "author": "moment in time",
  "cityLocation": "earth - Iraq",
  "Latitude": "33.3671531",
  "Longitude": "44.3561517",
  "Interiors": false,
  "Water": false,
  "Snow": false,
  "Animals": false,
  "DayVideo": false,
  "City": true,
  "Rain": false,
  "Nature": false,
  "Night": true,
  "dateRecording": 1786406400,
  "timeRecording": "20:36",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 202
 },
 {
  "url1": "1217374751",
  "url2": "ecc301fb76",
  "author": "INDIAN FLAG",
  "cityLocation": "Delhi - India",
  "Latitude": "28.6138954",
  "Longitude": "77.2090057",
  "Interiors": false,
  "Water": false,
  "Snow": false,
  "Animals": false,
  "DayVideo": false,
  "City": true,
  "Rain": false,
  "Nature": true,
  "Night": false,
  "dateRecording": 1786406400,
  "timeRecording": "08:37",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 203
 },
 {
  "url1": "1217279356",
  "url2": "0fad0a5b6b",
  "author": "Jo",
  "cityLocation": "Hangleton - UK",
  "Latitude": "50.8442426",
  "Longitude": "-0.1933855",
  "Interiors": false,
  "Water": false,
  "Snow": false,
  "Animals": true,
  "DayVideo": true,
  "City": false,
  "Rain": false,
  "Nature": false,
  "Night": false,
  "dateRecording": 1786406400,
  "timeRecording": "11:24",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 204
 },
 {
  "url1": "1217426729",
  "url2": "8d0bfae703",
  "author": "ElCorcheasZgz",
  "cityLocation": "Zaragoza - Spain",
  "Latitude": "41.6521342",
  "Longitude": "-0.8809428",
  "Interiors": false,
  "Water": false,
  "Snow": false,
  "Animals": false,
  "DayVideo": true,
  "City": true,
  "Rain": false,
  "Nature": false,
  "Night": false,
  "dateRecording": 1786406400,
  "timeRecording": "21:05",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 205
 },
 {
  "url1": "1217783144",
  "url2": "4fb95d5e4c",
  "author": "Clouds",
  "cityLocation": "Bogotá - Colombia",
  "Latitude": "4.6533817",
  "Longitude": "-74.0836331",
  "Interiors": false,
  "Water": false,
  "Snow": false,
  "Animals": false,
  "DayVideo": true,
  "City": false,
  "Rain": false,
  "Nature": false,
  "Night": false,
  "dateRecording": 1786492800,
  "timeRecording": "11:43",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 206
 },
 {
  "url1": "1217808926",
  "url2": "34f7f1bccb",
  "author": "Layla",
  "cityLocation": "Mississauga, Ontario - Canada",
  "Latitude": "43.5896231",
  "Longitude": "-79.6443879",
  "Interiors": false,
  "Water": false,
  "Snow": false,
  "Animals": false,
  "DayVideo": false,
  "City": false,
  "Rain": true,
  "Nature": true,
  "Night": false,
  "dateRecording": 1786492800,
  "timeRecording": "19:32",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 207
 },
 {
  "url1": "1217843453",
  "url2": "940e16d844",
  "author": "Ankur",
  "cityLocation": "Ahmedabad - India",
  "Latitude": "23.0215374",
  "Longitude": "72.5800568",
  "Interiors": false,
  "Water": false,
  "Snow": false,
  "Animals": false,
  "DayVideo": true,
  "City": false,
  "Rain": false,
  "Nature": true,
  "Night": false,
  "dateRecording": 1786579200,
  "timeRecording": "08:06",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 208
 },
 {
  "url1": "1217950460",
  "url2": "e468092c45",
  "author": "Morning",
  "cityLocation": "Hartsdale, New York - USA",
  "Latitude": "41.0130865",
  "Longitude": "-73.8089743",
  "Interiors": false,
  "Water": false,
  "Snow": false,
  "Animals": false,
  "DayVideo": true,
  "City": false,
  "Rain": false,
  "Nature": true,
  "Night": false,
  "dateRecording": 1786579200,
  "timeRecording": "07:35",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 209
 },
 {
  "url1": "1217915877",
  "url2": "02fa8cf3cc",
  "author": "Thiago Oliveira Basso",
  "cityLocation": "Barcelona - Spain",
  "Latitude": "41.3825802",
  "Longitude": "2.1770730",
  "Interiors": false,
  "Water": true,
  "Snow": false,
  "Animals": false,
  "DayVideo": true,
  "City": true,
  "Rain": false,
  "Nature": true,
  "Night": true,
  "dateRecording": 1786492800,
  "timeRecording": "20:30",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 210
 },
 {
  "url1": "1217903916",
  "url2": "2270f32b31",
  "author": "Monsoon",
  "cityLocation": "Raipur, Chhattisgarh - India",
  "Latitude": "21.2380912",
  "Longitude": "81.6336993",
  "Interiors": false,
  "Water": false,
  "Snow": false,
  "Animals": false,
  "DayVideo": false,
  "City": false,
  "Rain": false,
  "Nature": true,
  "Night": false,
  "dateRecording": 1786579200,
  "timeRecording": "14:10",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 211
 },
 {
  "url1": "1217883375",
  "url2": "eff1e052c4",
  "author": "Moki",
  "cityLocation": "Chofu, Tokyo - Japan",
  "Latitude": "35.6506036",
  "Longitude": "139.5407066",
  "Interiors": false,
  "Water": false,
  "Snow": false,
  "Animals": false,
  "DayVideo": true,
  "City": true,
  "Rain": true,
  "Nature": false,
  "Night": false,
  "dateRecording": 1786579200,
  "timeRecording": "15:00",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 212
 },
 {
  "url1": "1218220303",
  "url2": "376e9352a4",
  "author": "Drizzling",
  "cityLocation": "Raipur, Chhattisgarh - India",
  "Latitude": "21.2380912",
  "Longitude": "81.6336993",
  "Interiors": false,
  "Water": false,
  "Snow": false,
  "Animals": false,
  "DayVideo": false,
  "City": false,
  "Rain": true,
  "Nature": false,
  "Night": false,
  "dateRecording": 1786665600,
  "timeRecording": "11:04",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 213
 },
 {
  "url1": "1218238896",
  "url2": "7c2b8e2522",
  "author": "Shona",
  "cityLocation": "Greater Noida - India",
  "Latitude": "28.4670734",
  "Longitude": "77.5137649",
  "Interiors": false,
  "Water": true,
  "Snow": false,
  "Animals": false,
  "DayVideo": false,
  "City": true,
  "Rain": true,
  "Nature": true,
  "Night": false,
  "dateRecording": 1786665600,
  "timeRecording": "13:13",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 214
 },
 {
  "url1": "1218358254",
  "url2": "7e7664449a",
  "author": "Partial ocean view",
  "cityLocation": "Negril - Jamaica",
  "Latitude": "18.2779531",
  "Longitude": "-78.3494771",
  "Interiors": false,
  "Water": true,
  "Snow": false,
  "Animals": false,
  "DayVideo": true,
  "City": false,
  "Rain": false,
  "Nature": true,
  "Night": false,
  "dateRecording": 1786665600,
  "timeRecording": "11:00",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 215
 },
 {
  "url1": "1218382819",
  "url2": "6143f71ef3",
  "author": "Acapulco",
  "cityLocation": "Acapulco - Mexico",
  "Latitude": "16.8680495",
  "Longitude": "-99.8940182",
  "Interiors": false,
  "Water": true,
  "Snow": false,
  "Animals": false,
  "DayVideo": true,
  "City": false,
  "Rain": false,
  "Nature": false,
  "Night": false,
  "dateRecording": 1786665600,
  "timeRecording": "12:21",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 216
 },
 {
  "url1": "1218465315",
  "url2": "b659fc20d5",
  "author": "Fortune Restaurant",
  "cityLocation": "Otek St Brgy, Baguio - Philippines",
  "Latitude": "",
  "Longitude": "",
  "Interiors": false,
  "Water": false,
  "Snow": false,
  "Animals": false,
  "DayVideo": false,
  "City": true,
  "Rain": true,
  "Nature": false,
  "Night": true,
  "dateRecording": 1786665600,
  "timeRecording": "19:02",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 217
 },
 {
  "url1": "1218464306",
  "url2": "56cfe2a3c8",
  "author": "Brisamar",
  "cityLocation": "Acapulco - Mexico",
  "Latitude": "16.8680495",
  "Longitude": "-99.8940182",
  "Interiors": false,
  "Water": true,
  "Snow": false,
  "Animals": false,
  "DayVideo": false,
  "City": true,
  "Rain": false,
  "Nature": false,
  "Night": false,
  "dateRecording": 1786665600,
  "timeRecording": "19:10",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 218
 },
 {
  "url1": "1218420042",
  "url2": "af6dfb0ab7",
  "author": "Govind",
  "cityLocation": "Toronto - Canada",
  "Latitude": "43.6534817",
  "Longitude": "-79.3839347",
  "Interiors": false,
  "Water": true,
  "Snow": false,
  "Animals": false,
  "DayVideo": true,
  "City": true,
  "Rain": false,
  "Nature": true,
  "Night": false,
  "dateRecording": 1786665600,
  "timeRecording": "17:30",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 219
 },
 {
  "url1": "1218388282",
  "url2": "4ed6e2a763",
  "author": "Acapulco at nigth",
  "cityLocation": "Acapulco - Mexico",
  "Latitude": "16.8680495",
  "Longitude": "-99.8940182",
  "Interiors": false,
  "Water": false,
  "Snow": false,
  "Animals": false,
  "DayVideo": false,
  "City": false,
  "Rain": true,
  "Nature": false,
  "Night": false,
  "dateRecording": 1785542400,
  "timeRecording": "23:27",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 220
 },
 {
  "url1": "1218473415",
  "url2": "55e169ab15",
  "author": "R",
  "cityLocation": "HONG KONG - China",
  "Latitude": "22.3506270",
  "Longitude": "114.1849161",
  "Interiors": false,
  "Water": false,
  "Snow": false,
  "Animals": false,
  "DayVideo": true,
  "City": true,
  "Rain": true,
  "Nature": false,
  "Night": false,
  "dateRecording": 1785024000,
  "timeRecording": "16:56",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 221
 },
 {
  "url1": "1218511166",
  "url2": "d93da183bf",
  "author": "Leon",
  "cityLocation": "Petershausen, Dachau - Germany",
  "Latitude": "48.4087889",
  "Longitude": "11.4698608",
  "Interiors": false,
  "Water": false,
  "Snow": false,
  "Animals": false,
  "DayVideo": true,
  "City": false,
  "Rain": false,
  "Nature": true,
  "Night": false,
  "dateRecording": 1786752000,
  "timeRecording": "13:15",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 222
 },
 {
  "url1": "1218530273",
  "url2": "664665a88e",
  "author": "Framing the Cityscape",
  "cityLocation": "Chittagong - Bangladesh",
  "Latitude": "22.3337780",
  "Longitude": "91.8344348",
  "Interiors": false,
  "Water": false,
  "Snow": false,
  "Animals": false,
  "DayVideo": true,
  "City": true,
  "Rain": false,
  "Nature": true,
  "Night": true,
  "dateRecording": 1786752000,
  "timeRecording": "18:00",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 223
 },
 {
  "url1": "1218548814",
  "url2": "dd519628cc",
  "author": "Ahmad",
  "cityLocation": "Amman - Jordan",
  "Latitude": "31.9515694",
  "Longitude": "35.9239625",
  "Interiors": false,
  "Water": false,
  "Snow": false,
  "Animals": false,
  "DayVideo": false,
  "City": true,
  "Rain": false,
  "Nature": true,
  "Night": true,
  "dateRecording": 1786752000,
  "timeRecording": "19:40",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 224
 },
 {
  "url1": "1218741559",
  "url2": "9b98929521",
  "author": "Mohit",
  "cityLocation": "Amsterdam - Netherlands",
  "Latitude": "52.3730796",
  "Longitude": "4.8924534",
  "Interiors": false,
  "Water": false,
  "Snow": false,
  "Animals": false,
  "DayVideo": true,
  "City": true,
  "Rain": false,
  "Nature": false,
  "Night": false,
  "dateRecording": 1786838400,
  "timeRecording": "16:06",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 225
 },
 {
  "url1": "1218711214",
  "url2": "8d056b1e6c",
  "author": "Joyas",
  "cityLocation": "Acapulco - Mexico",
  "Latitude": "16.8680495",
  "Longitude": "-99.8940182",
  "Interiors": false,
  "Water": false,
  "Snow": false,
  "Animals": false,
  "DayVideo": false,
  "City": true,
  "Rain": false,
  "Nature": false,
  "Night": false,
  "dateRecording": 1786838400,
  "timeRecording": "12:30",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 226
 },
 {
  "url1": "1218650423",
  "url2": "f2d24271c8",
  "author": "Taiyo",
  "cityLocation": "Nova Scotia - Canada",
  "Latitude": "45.1960403",
  "Longitude": "-63.1653789",
  "Interiors": false,
  "Water": true,
  "Snow": false,
  "Animals": false,
  "DayVideo": false,
  "City": false,
  "Rain": false,
  "Nature": true,
  "Night": false,
  "dateRecording": 1786752000,
  "timeRecording": "20:30",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 227
 },
 {
  "url1": "1218632779",
  "url2": "868f60be22",
  "author": "Ece",
  "cityLocation": "Ankara - Turkey",
  "Latitude": "39.9207759",
  "Longitude": "32.8540497",
  "Interiors": false,
  "Water": false,
  "Snow": false,
  "Animals": false,
  "DayVideo": false,
  "City": true,
  "Rain": false,
  "Nature": false,
  "Night": false,
  "dateRecording": 1786838400,
  "timeRecording": "11:20",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 228
 },
 {
  "url1": "1200532181",
  "url2": "be261acaf5",
  "author": "Bells",
  "cityLocation": "Paraná - Brasil",
  "Latitude": "-24.4842187",
  "Longitude": "-51.8148872",
  "Interiors": false,
  "Water": false,
  "Snow": false,
  "Animals": false,
  "DayVideo": true,
  "City": false,
  "Rain": false,
  "Nature": true,
  "Night": false,
  "dateRecording": 1781136000,
  "timeRecording": "14:25",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 229
 },
 {
  "url1": "1200696825",
  "url2": "e0ebd6dd27",
  "author": "Matvey",
  "cityLocation": "Kungur. Perm Krai - Russia",
  "Latitude": "57.4288440",
  "Longitude": "56.9443280",
  "Interiors": false,
  "Water": false,
  "Snow": false,
  "Animals": false,
  "DayVideo": true,
  "City": true,
  "Rain": false,
  "Nature": false,
  "Night": false,
  "dateRecording": 1781222400,
  "timeRecording": "13:33",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 230
 },
 {
  "url1": "1200677514",
  "url2": "2098aa8769",
  "author": "Preston Circus",
  "cityLocation": "Preston Circus, Brighton - UK",
  "Latitude": "50.8340912",
  "Longitude": "-0.1397523",
  "Interiors": false,
  "Water": false,
  "Snow": false,
  "Animals": false,
  "DayVideo": true,
  "City": true,
  "Rain": false,
  "Nature": false,
  "Night": false,
  "dateRecording": 1780617600,
  "timeRecording": "06:05",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 231
 },
 {
  "url1": "1200660627",
  "url2": "84bc22489b",
  "author": "Mountain",
  "cityLocation": "Burchimulla - Uzbekistan",
  "Latitude": "",
  "Longitude": "",
  "Interiors": false,
  "Water": true,
  "Snow": false,
  "Animals": false,
  "DayVideo": true,
  "City": false,
  "Rain": false,
  "Nature": true,
  "Night": false,
  "dateRecording": 1781222400,
  "timeRecording": "10:23",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 232
 },
 {
  "url1": "1200777043",
  "url2": "04743d7f7a",
  "author": "Svetlana",
  "cityLocation": "Almaty - Kazakhstan",
  "Latitude": "43.2363924",
  "Longitude": "76.9457275",
  "Interiors": false,
  "Water": false,
  "Snow": false,
  "Animals": false,
  "DayVideo": true,
  "City": false,
  "Rain": true,
  "Nature": false,
  "Night": false,
  "dateRecording": 1781222400,
  "timeRecording": "18:22",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 233
 },
 {
  "url1": "1200777817",
  "url2": "ce9cf1e8f9",
  "author": "Санкт-Петербург",
  "cityLocation": "Лахта центр - Россия",
  "Latitude": "59.9871202",
  "Longitude": "30.1707207",
  "Interiors": false,
  "Water": true,
  "Snow": false,
  "Animals": false,
  "DayVideo": false,
  "City": false,
  "Rain": false,
  "Nature": false,
  "Night": false,
  "dateRecording": 1781222400,
  "timeRecording": "16:44",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 234
 },
 {
  "url1": "1200753606",
  "url2": "4d016d9634",
  "author": "Megan",
  "cityLocation": "Wales - UK",
  "Latitude": "52.2928116",
  "Longitude": "-3.7389300",
  "Interiors": false,
  "Water": false,
  "Snow": false,
  "Animals": false,
  "DayVideo": true,
  "City": false,
  "Rain": false,
  "Nature": true,
  "Night": false,
  "dateRecording": 1781222400,
  "timeRecording": "13:18",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 235
 },
 {
  "url1": "1200812659",
  "url2": "34f0008587",
  "author": "Guzal",
  "cityLocation": "Tashkent - Uzbekistan",
  "Latitude": "41.3123363",
  "Longitude": "69.2787079",
  "Interiors": false,
  "Water": false,
  "Snow": false,
  "Animals": false,
  "DayVideo": false,
  "City": true,
  "Rain": false,
  "Nature": false,
  "Night": true,
  "dateRecording": 1781222400,
  "timeRecording": "20:28",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 236
 },
 {
  "url1": "1200871877",
  "url2": "fbe67f9eba",
  "author": "Ram",
  "cityLocation": "Kalamazoo, MI - USA",
  "Latitude": "42.2917070",
  "Longitude": "-85.5872286",
  "Interiors": false,
  "Water": true,
  "Snow": false,
  "Animals": false,
  "DayVideo": true,
  "City": false,
  "Rain": false,
  "Nature": true,
  "Night": false,
  "dateRecording": 1781222400,
  "timeRecording": "15:07",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 237
 },
 {
  "url1": "1200962985",
  "url2": "068d8f75c4",
  "author": "Wild Owl",
  "cityLocation": "Gold Coast - Australia",
  "Latitude": "-28.0023731",
  "Longitude": "153.4145987",
  "Interiors": false,
  "Water": true,
  "Snow": false,
  "Animals": false,
  "DayVideo": true,
  "City": true,
  "Rain": true,
  "Nature": true,
  "Night": false,
  "dateRecording": 1781308800,
  "timeRecording": "16:09",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 238
 },
 {
  "url1": "1201021910",
  "url2": "173e4bd89d",
  "author": "Viktor",
  "cityLocation": "Korenovsk - Russia",
  "Latitude": "45.4635863",
  "Longitude": "39.4487565",
  "Interiors": false,
  "Water": false,
  "Snow": false,
  "Animals": false,
  "DayVideo": false,
  "City": false,
  "Rain": true,
  "Nature": true,
  "Night": false,
  "dateRecording": 1781308800,
  "timeRecording": "17:20",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 239
 },
 {
  "url1": "1200990392",
  "url2": "a3a858250f",
  "author": "K",
  "cityLocation": "Warszawa - Poland",
  "Latitude": "52.2333742",
  "Longitude": "21.0711489",
  "Interiors": false,
  "Water": false,
  "Snow": false,
  "Animals": false,
  "DayVideo": false,
  "City": true,
  "Rain": true,
  "Nature": true,
  "Night": false,
  "dateRecording": 1781308800,
  "timeRecording": "11:40",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 240
 },
 {
  "url1": "1200986832",
  "url2": "25ed928bf3",
  "author": "Kate612",
  "cityLocation": "Kyiv region - Ukraine",
  "Latitude": "50.4730906",
  "Longitude": "30.4673970",
  "Interiors": false,
  "Water": false,
  "Snow": false,
  "Animals": false,
  "DayVideo": true,
  "City": false,
  "Rain": false,
  "Nature": true,
  "Night": false,
  "dateRecording": 1781308800,
  "timeRecording": "13:12",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 241
 },
 {
  "url1": "1201045827",
  "url2": "f4cc06d17b",
  "author": "K",
  "cityLocation": "Ragged Point, CA - USA",
  "Latitude": "35.7595645",
  "Longitude": "-121.3268269",
  "Interiors": false,
  "Water": true,
  "Snow": false,
  "Animals": false,
  "DayVideo": true,
  "City": false,
  "Rain": false,
  "Nature": true,
  "Night": false,
  "dateRecording": 1780704000,
  "timeRecording": "07:30",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 242
 },
 {
  "url1": "1201060548",
  "url2": "a983be2779",
  "author": "Nata",
  "cityLocation": "Melniki - Ukraine",
  "Latitude": "49.0606679",
  "Longitude": "27.8631787",
  "Interiors": false,
  "Water": false,
  "Snow": false,
  "Animals": false,
  "DayVideo": false,
  "City": false,
  "Rain": false,
  "Nature": true,
  "Night": false,
  "dateRecording": 1781308800,
  "timeRecording": "21:19",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 243
 },
 {
  "url1": "1201082313",
  "url2": "3794c0a26f",
  "author": "Namrata",
  "cityLocation": "Clemson, South Carolina - USA",
  "Latitude": "34.6850749",
  "Longitude": "-82.8364111",
  "Interiors": false,
  "Water": false,
  "Snow": false,
  "Animals": false,
  "DayVideo": true,
  "City": false,
  "Rain": false,
  "Nature": true,
  "Night": false,
  "dateRecording": 1781308800,
  "timeRecording": "18:22",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 244
 },
 {
  "url1": "1201077704",
  "url2": "587a283da7",
  "author": "Diwali",
  "cityLocation": "Noida - India",
  "Latitude": "28.5706333",
  "Longitude": "77.3272147",
  "Interiors": false,
  "Water": false,
  "Snow": false,
  "Animals": false,
  "DayVideo": false,
  "City": true,
  "Rain": false,
  "Nature": false,
  "Night": true,
  "dateRecording": 1730332800,
  "timeRecording": "22:09",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 245
 },
 {
  "url1": "1201027192",
  "url2": "54aa4c616e",
  "author": "Diana",
  "cityLocation": "Bendery - Moldova",
  "Latitude": "46.8218177",
  "Longitude": "29.4819196",
  "Interiors": false,
  "Water": false,
  "Snow": false,
  "Animals": false,
  "DayVideo": true,
  "City": true,
  "Rain": false,
  "Nature": false,
  "Night": true,
  "dateRecording": 1781308800,
  "timeRecording": "17:07",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 246
 },
 {
  "url1": "1200799003",
  "url2": "e94f26c680",
  "author": "Muhammed",
  "cityLocation": "Kalasipalya, Bengaluru - India",
  "Latitude": "12.9584500",
  "Longitude": "77.5808223",
  "Interiors": false,
  "Water": false,
  "Snow": false,
  "Animals": false,
  "DayVideo": true,
  "City": true,
  "Rain": true,
  "Nature": false,
  "Night": false,
  "dateRecording": 1781222400,
  "timeRecording": "16:55",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 247
 },
 {
  "url1": "1201168469",
  "url2": "6b954197de",
  "author": "Mel",
  "cityLocation": "Porogi dam - Russia",
  "Latitude": "",
  "Longitude": "",
  "Interiors": false,
  "Water": true,
  "Snow": false,
  "Animals": false,
  "DayVideo": false,
  "City": false,
  "Rain": false,
  "Nature": true,
  "Night": false,
  "dateRecording": 1781395200,
  "timeRecording": "12:00",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 248
 },
 {
  "url1": "1201161649",
  "url2": "7f06f66582",
  "author": "Maika Leonova",
  "cityLocation": "Almaty, Besqaynar - Kazakhstan",
  "Latitude": "43.2149187",
  "Longitude": "77.1040456",
  "Interiors": false,
  "Water": false,
  "Snow": false,
  "Animals": false,
  "DayVideo": true,
  "City": false,
  "Rain": false,
  "Nature": true,
  "Night": false,
  "dateRecording": 1781308800,
  "timeRecording": "04:01",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 249
 },
 {
  "url1": "1201159823",
  "url2": "d788edb212",
  "author": "Fedor",
  "cityLocation": "Rostov-on-Don - Russia",
  "Latitude": "47.2610441",
  "Longitude": "39.7249086",
  "Interiors": false,
  "Water": false,
  "Snow": false,
  "Animals": false,
  "DayVideo": true,
  "City": false,
  "Rain": false,
  "Nature": true,
  "Night": false,
  "dateRecording": 1781395200,
  "timeRecording": "15:20",
  "vimeoToken": "TP_VIMEO_TOKEN_3",
  "liveSequenceId": 250
 }
]
export default videos;